var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 681 634",
    width: 681,
    height: 634,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 357.8,
    y1: 407.8,
    x2: 593.1,
    y2: 407.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 357.8,
    y1: 350,
    x2: 593.1,
    y2: 350,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#653fb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2c1361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 363.5,
    y1: 373.4,
    x2: 505,
    y2: 295.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 410.1,
    y1: 427.4,
    x2: 468.1,
    y2: 330.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 478,
    cy: 450.8,
    r: 83.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af8afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g6",
    cx: 411.8,
    cy: 434.6,
    r: 83.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f18ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 333.3,
    y1: 709.9,
    x2: -35.5,
    y2: 199.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 645,
    y1: -182.1,
    x2: 953.5,
    y2: 281.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 332.9,
    y1: 742.1,
    x2: 42.5,
    y2: 278.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g10",
    cx: 646.1,
    cy: 225.3,
    r: 48.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af8afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 251.1,
    y1: 571.7,
    x2: 254.6,
    y2: 430.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g12",
    cx: 98.3,
    cy: 444.8,
    r: 59.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af8afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 135.7,
    y1: 607,
    x2: 420.1,
    y2: 518,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 223.6,
    y1: 626.6,
    x2: 322.3,
    y2: 417.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 220.5,
    y1: 419.8,
    x2: 102.4,
    y2: 419.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 536.6,
    y1: 631.1,
    x2: 163.4,
    y2: 366.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: -184.8,
    y1: -139.2,
    x2: -310,
    y2: 77.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g18",
    cx: 60.2,
    cy: 202.2,
    r: 227.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g19",
    cx: 98.2,
    cy: 186,
    r: 133.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af8afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 178.9,
    y1: 611.1,
    x2: 561.2,
    y2: 491.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 544.6,
    y1: 676.2,
    x2: 736.2,
    y2: 271.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 220.4,
    y1: 118,
    x2: 102.3,
    y2: 118,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 568.6,
    y1: -74.9,
    x2: 720,
    y2: 302.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g24",
    cx: 288.8,
    cy: 469.3,
    r: 95.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5f5c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 397.7,
    y1: 370.9,
    x2: 305.5,
    y2: 485.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 234.4,
    y1: 357.7,
    x2: 285.8,
    y2: 459.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 247.2,
    y1: 386.9,
    x2: 306,
    y2: 386.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#501397"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 247.3,
    y1: 454.3,
    x2: 306.4,
    y2: 454.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 247.1,
    y1: 461.7,
    x2: 247.1,
    y2: 461.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 247.3,
    y1: 461.2,
    x2: 306.4,
    y2: 461.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 307,
    y1: 461.7,
    x2: 307,
    y2: 461.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 366.7,
    y1: 391.9,
    x2: 286.5,
    y2: 472.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g33",
    cx: 264.2,
    cy: 467.3,
    r: 37.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 320.4,
    y1: 431.6,
    x2: 260.4,
    y2: 491.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g35",
    cx: 287.6,
    cy: 440.2,
    r: 16.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 320,
    y1: 414,
    x2: 270.5,
    y2: 463.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g37",
    cx: 261,
    cy: 469.5,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g38",
    cx: 290.7,
    cy: 443.7,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 265.9,
    y1: 447.3,
    x2: 288.2,
    y2: 447.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 309.9,
    y1: 445.9,
    x2: 284.9,
    y2: 459.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g41",
    cx: 261.7,
    cy: 455.3,
    r: 20,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g42",
    cx: 276.6,
    cy: 444.7,
    r: 22.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#785c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 247.3,
    y1: 420,
    x2: 306.4,
    y2: 420,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 247.1,
    y1: 427.3,
    x2: 247.1,
    y2: 427.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 247.3,
    y1: 426.8,
    x2: 306.4,
    y2: 426.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 307,
    y1: 427.3,
    x2: 307,
    y2: 427.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 366.7,
    y1: 357.5,
    x2: 286.5,
    y2: 438.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g48",
    cx: 264.2,
    cy: 432.9,
    r: 37.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: 320.4,
    y1: 397.2,
    x2: 260.4,
    y2: 457.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g50",
    cx: 287.6,
    cy: 405.8,
    r: 16.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 320,
    y1: 379.7,
    x2: 270.5,
    y2: 429.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g52",
    cx: 261,
    cy: 435.1,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g53",
    cx: 290.7,
    cy: 409.3,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x1: 265.9,
    y1: 412.9,
    x2: 288.2,
    y2: 412.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g55",
    x1: 309.9,
    y1: 411.5,
    x2: 284.9,
    y2: 425.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g56",
    cx: 261.7,
    cy: 421,
    r: 20,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x1: 206.1,
    y1: 404,
    x2: 355.5,
    y2: 404,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 353.9,
    y1: 368.1,
    x2: 416.2,
    y2: 424.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g59",
    cx: 327.2,
    cy: 420.8,
    r: 24,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x1: 397.7,
    y1: 310.7,
    x2: 305.5,
    y2: 425.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g61",
    cx: 283.2,
    cy: 381.4,
    r: 39.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g62",
    cx: 276.6,
    cy: 409.8,
    r: 22.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#785c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x1: 276.6,
    y1: 454.9,
    x2: 297.8,
    y2: 454.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 196.7,
    y1: 459.5,
    x2: 354.2,
    y2: 459.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g65",
    x1: 380.2,
    y1: 399.6,
    x2: 304.4,
    y2: 505,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g66",
    cx: 303.8,
    cy: 481.6,
    r: 23.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x1: 247.2,
    y1: 425.4,
    x2: 276.7,
    y2: 425.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#671ab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ad34f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5513ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g68",
    x1: 196.2,
    y1: 425.2,
    x2: 356.8,
    y2: 425.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#671ab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ad34f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5513ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g69",
    x1: 206.1,
    y1: 466.2,
    x2: 355.5,
    y2: 466.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g70",
    x1: 196.7,
    y1: 483.5,
    x2: 354.2,
    y2: 483.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g71",
    x1: 196.2,
    y1: 466,
    x2: 356.8,
    y2: 466,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#671ab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ad34f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5513ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g72",
    x1: 333.3,
    y1: 366.3,
    x2: 229.2,
    y2: 498,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g73",
    cx: 239,
    cy: 457.2,
    r: 31.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g74",
    cx: 243.7,
    cy: 501,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g75",
    cx: 285.5,
    cy: 402.2,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g76",
    x1: 58.6,
    y1: 405.8,
    x2: 58.6,
    y2: 249.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdd65b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g77",
    x1: 247.3,
    y1: 384,
    x2: 306.4,
    y2: 384,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g78",
    x1: 247.1,
    y1: 391.3,
    x2: 247.1,
    y2: 391.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g79",
    x1: 247.3,
    y1: 390.8,
    x2: 306.4,
    y2: 390.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g80",
    x1: 307,
    y1: 391.3,
    x2: 307,
    y2: 391.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g81",
    x1: 366.7,
    y1: 321.6,
    x2: 286.5,
    y2: 402.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g82",
    cx: 264.2,
    cy: 396.9,
    r: 37.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g83",
    x1: 320.4,
    y1: 361.2,
    x2: 260.4,
    y2: 421.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g84",
    cx: 287.6,
    cy: 369.8,
    r: 16.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g85",
    x1: 320,
    y1: 343.7,
    x2: 270.5,
    y2: 393.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g86",
    cx: 261,
    cy: 399.1,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g87",
    cx: 290.7,
    cy: 373.3,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g88",
    x1: 265.9,
    y1: 376.9,
    x2: 288.2,
    y2: 376.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g89",
    x1: 309.9,
    y1: 375.6,
    x2: 284.9,
    y2: 389.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g90",
    cx: 261.7,
    cy: 385,
    r: 20,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g91",
    x1: 247.3,
    y1: 335.8,
    x2: 306.4,
    y2: 335.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g92",
    x1: 247.1,
    y1: 343.1,
    x2: 247.1,
    y2: 343.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g93",
    x1: 247.3,
    y1: 342.6,
    x2: 306.4,
    y2: 342.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g94",
    x1: 307,
    y1: 343.1,
    x2: 307,
    y2: 343.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95",
    x1: 366.7,
    y1: 273.4,
    x2: 286.5,
    y2: 354.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g96",
    cx: 264.2,
    cy: 348.7,
    r: 37.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g97",
    x1: 320.4,
    y1: 313,
    x2: 260.4,
    y2: 373.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g98",
    cx: 287.6,
    cy: 321.6,
    r: 16.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g99",
    x1: 320,
    y1: 295.5,
    x2: 270.5,
    y2: 345.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g100",
    cx: 261,
    cy: 350.9,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g101",
    cx: 290.7,
    cy: 325.1,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g102",
    x1: 265.9,
    y1: 328.7,
    x2: 288.2,
    y2: 328.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g103",
    x1: 309.9,
    y1: 327.3,
    x2: 284.9,
    y2: 341,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g104",
    cx: 261.7,
    cy: 336.8,
    r: 20,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g105",
    cx: 276.6,
    cy: 379.1,
    r: 22.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#785c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g106",
    x1: 797.5,
    y1: -186.1,
    x2: 959.7,
    y2: 123.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g107",
    x1: 796,
    y1: -185.1,
    x2: 957.8,
    y2: 123.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g108",
    x1: 794.5,
    y1: -184,
    x2: 955.8,
    y2: 123.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g109",
    x1: 792.9,
    y1: -183,
    x2: 953.9,
    y2: 123.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g110",
    x1: 791.4,
    y1: -181.9,
    x2: 951.9,
    y2: 124.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g111",
    x1: 789.9,
    y1: -180.9,
    x2: 950,
    y2: 124.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g112",
    x1: 788.3,
    y1: -179.8,
    x2: 948,
    y2: 124.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g113",
    x1: 786.8,
    y1: -178.7,
    x2: 946.1,
    y2: 124.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g114",
    x1: 785.3,
    y1: -177.7,
    x2: 944.1,
    y2: 125.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g115",
    x1: 783.7,
    y1: -176.7,
    x2: 942.2,
    y2: 125.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g116",
    x1: 782.2,
    y1: -175.6,
    x2: 940.2,
    y2: 125.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g117",
    x1: 780.7,
    y1: -174.6,
    x2: 938.3,
    y2: 125.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g118",
    x1: 296.7,
    y1: 641.4,
    x2: 45.5,
    y2: 150.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g119",
    cx: 563.8,
    cy: 140.8,
    r: 105.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g120",
    x1: 536.6,
    y1: 100.6,
    x2: 556.3,
    y2: 201.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g121",
    x1: 603.5,
    y1: 182.2,
    x2: 503,
    y2: 190.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g122",
    x1: 575.8,
    y1: 197.2,
    x2: 588.6,
    y2: 120.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g123",
    x1: 510.5,
    y1: 162.9,
    x2: 552.1,
    y2: 162.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g124",
    x1: 549.3,
    y1: 247.7,
    x2: 552.4,
    y2: 355.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g125",
    x1: 592.4,
    y1: 266.5,
    x2: 499.4,
    y2: 351.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g126",
    x1: 583.8,
    y1: 335.7,
    x2: 487.4,
    y2: 262,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g127",
    x1: 516.3,
    y1: 256.3,
    x2: 494.8,
    y2: 350.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g128",
    x1: 616.4,
    y1: 345.5,
    x2: 551.7,
    y2: 222.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g129",
    x1: 478.2,
    y1: 530.2,
    x2: 550.6,
    y2: 467.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g130",
    x1: 493.2,
    y1: 551.9,
    x2: 579.2,
    y2: 477.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g131",
    x1: 507.1,
    y1: 570,
    x2: 606.8,
    y2: 484,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g132",
    x1: 519.3,
    y1: 588.4,
    x2: 632.5,
    y2: 490.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g133",
    x1: 531,
    y1: 603.3,
    x2: 657.9,
    y2: 493.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g134",
    x1: 554.3,
    y1: 464.9,
    x2: 412.1,
    y2: 307.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g135",
    x1: 505.2,
    y1: 461,
    x2: 504.7,
    y2: 511.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g136",
    x1: 524.9,
    y1: 455.1,
    x2: 525.7,
    y2: 511.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g137",
    x1: 573.2,
    y1: 507.2,
    x2: 588.8,
    y2: 487.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g138",
    cx: 558.2,
    cy: 477.7,
    r: 20.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g139",
    x1: 583.7,
    y1: 438.2,
    x2: 441.5,
    y2: 280.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g140",
    x1: 414.8,
    y1: 442.4,
    x2: 413.8,
    y2: 540.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g141",
    x1: 434.1,
    y1: 443.1,
    x2: 435.6,
    y2: 544,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g142",
    x1: 684.3,
    y1: 572.2,
    x2: 714.1,
    y2: 535.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g143",
    cx: 587.6,
    cy: 462,
    r: 31.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g144",
    x1: 613.2,
    y1: 409.7,
    x2: 471,
    y2: 252,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g145",
    x1: 228.7,
    y1: 412.2,
    x2: 227.2,
    y2: 567,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g146",
    x1: 247.4,
    y1: 416.6,
    x2: 249.7,
    y2: 575.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g147",
    x1: 853.6,
    y1: 682,
    x2: 897.4,
    y2: 627.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g148",
    cx: 617.2,
    cy: 444.5,
    r: 45.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g149",
    x1: 642.9,
    y1: 380.5,
    x2: 500.7,
    y2: 222.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g150",
    x1: -67.9,
    y1: 380.3,
    x2: -70,
    y2: 593.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g151",
    x1: -49.8,
    y1: 391,
    x2: -46.7,
    y2: 609.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g152",
    x1: 1090.3,
    y1: 846.6,
    x2: 1148.7,
    y2: 774.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g153",
    cx: 646.8,
    cy: 426.6,
    r: 60.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g154",
    x1: 673.4,
    y1: 351.8,
    x2: 531.2,
    y2: 194.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g155",
    x1: -462.2,
    y1: 347.9,
    x2: -464.9,
    y2: 619.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g156",
    x1: -444.8,
    y1: 367.3,
    x2: -440.8,
    y2: 645.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g157",
    x1: 1387.2,
    y1: 1059.4,
    x2: 1460.1,
    y2: 969.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g158",
    cx: 677.3,
    cy: 409.1,
    r: 76.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g159",
    x1: 454.2,
    y1: -258.4,
    x2: 657.5,
    y2: 129.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g160",
    x1: 452.5,
    y1: -252.5,
    x2: 653.5,
    y2: 130.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g161",
    x1: 450.9,
    y1: -246.6,
    x2: 649.5,
    y2: 132.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g162",
    x1: 449.2,
    y1: -240.7,
    x2: 645.5,
    y2: 133.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g163",
    x1: 447.6,
    y1: -234.8,
    x2: 641.6,
    y2: 135.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g164",
    x1: 446,
    y1: -228.8,
    x2: 637.6,
    y2: 136.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g165",
    x1: 444.3,
    y1: -222.9,
    x2: 633.6,
    y2: 138,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g166",
    x1: 442.7,
    y1: -217,
    x2: 629.6,
    y2: 139.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g167",
    x1: 441,
    y1: -211.1,
    x2: 625.7,
    y2: 141,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g168",
    x1: 439.4,
    y1: -205.2,
    x2: 621.7,
    y2: 142.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g169",
    x1: 437.7,
    y1: -199.3,
    x2: 617.7,
    y2: 144,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g170",
    x1: 436.1,
    y1: -193.3,
    x2: 613.8,
    y2: 145.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g171",
    x1: 322.1,
    y1: 600.9,
    x2: 28.7,
    y2: 27.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g172",
    cx: 384.8,
    cy: 98.7,
    r: 202.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g173",
    x1: -428.2,
    y1: -4.7,
    x2: -392,
    y2: -123.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g174",
    x1: -612.7,
    y1: -63.9,
    x2: -570.3,
    y2: -203.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g175",
    x1: -981.1,
    y1: -177.5,
    x2: -939,
    y2: -315.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g176",
    x1: -84.4,
    y1: 101.9,
    x2: -44.5,
    y2: -29.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g177",
    x1: 13.6,
    y1: 131.2,
    x2: 43.4,
    y2: 33.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g178",
    x1: -624.2,
    y1: -72.4,
    x2: -579.4,
    y2: -219.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g179",
    x1: -285.5,
    y1: 31.7,
    x2: -245,
    y2: -101.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g180",
    x1: -333.9,
    y1: 28.4,
    x2: -289.5,
    y2: -117.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g181",
    x1: 39.1,
    y1: 146.1,
    x2: 83.8,
    y2: -0.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g182",
    x1: -228.5,
    y1: 60.7,
    x2: -190.2,
    y2: -65.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g183",
    x1: -223.6,
    y1: 59.3,
    x2: -194.7,
    y2: -35.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g184",
    x1: -425,
    y1: -2.1,
    x2: -395.9,
    y2: -97.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g185",
    x1: -932.8,
    y1: -160.7,
    x2: -899.9,
    y2: -268.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g186",
    x1: -428.2,
    y1: 2.1,
    x2: -392,
    y2: -117,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g187",
    x1: -358.3,
    y1: 22.4,
    x2: -321.7,
    y2: -97.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g188",
    x1: -576.8,
    y1: -44.4,
    x2: -541.5,
    y2: -160.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g189",
    x1: -84.4,
    y1: 108.8,
    x2: -44.5,
    y2: -22.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g190",
    x1: -21.5,
    y1: 127.3,
    x2: 9.8,
    y2: 24.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g191",
    x1: -433.2,
    y1: -4.8,
    x2: -392.7,
    y2: -138,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g192",
    x1: -285.5,
    y1: 38.6,
    x2: -245,
    y2: -94.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g193",
    x1: -176.4,
    y1: 82.2,
    x2: -137.6,
    y2: -45.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g194",
    x1: 39.1,
    y1: 153,
    x2: 83.8,
    y2: 6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g195",
    x1: -228.5,
    y1: 67.6,
    x2: -190.2,
    y2: -58.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g196",
    x1: 52.8,
    y1: 172,
    x2: 94.8,
    y2: 10.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g197",
    x1: -174.4,
    y1: 111.4,
    x2: -136.5,
    y2: -34,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g198",
    x1: -121.2,
    y1: 123.9,
    x2: -82.9,
    y2: -23.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g199",
    x1: 178.5,
    y1: 212.1,
    x2: 229.9,
    y2: 14.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g200",
    x1: 83.1,
    y1: 182.3,
    x2: 126.8,
    y2: 14.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g201",
    x1: 45.6,
    y1: 177,
    x2: 89,
    y2: 10.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g202",
    x1: 204.9,
    y1: 248.9,
    x2: 279.5,
    y2: -37.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g203",
    x1: 152.7,
    y1: 213.3,
    x2: 205,
    y2: 12.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g204",
    x1: 80.2,
    y1: 173.5,
    x2: 121.7,
    y2: 14,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g205",
    x1: 247.8,
    y1: 211.1,
    x2: 296.6,
    y2: 23.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g206",
    x1: -223.5,
    y1: 66.2,
    x2: -194.7,
    y2: -28.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g207",
    x1: -275.1,
    y1: 52.9,
    x2: -248.7,
    y2: -34.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g208",
    x1: -693.4,
    y1: -77.8,
    x2: -663.5,
    y2: -176.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g209",
    x1: -10,
    y1: 148.1,
    x2: 29.2,
    y2: -2.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g210",
    x1: -33.8,
    y1: 148.4,
    x2: -4,
    y2: 34.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g211",
    x1: 49.5,
    y1: 283.3,
    x2: 51.3,
    y2: 167.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g212",
    x1: 494.3,
    y1: 376.8,
    x2: 497.8,
    y2: 243.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g213",
    x1: 490.7,
    y1: 372.1,
    x2: 500.2,
    y2: 241.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g214",
    x1: 487.1,
    y1: 366.9,
    x2: 502.5,
    y2: 240.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g215",
    x1: 483.7,
    y1: 361.2,
    x2: 504.6,
    y2: 239.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g216",
    x1: 480.4,
    y1: 355,
    x2: 506.5,
    y2: 238.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e3c3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g217",
    x1: 477.4,
    y1: 348.5,
    x2: 508.1,
    y2: 237.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3839"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g218",
    x1: 474.5,
    y1: 341.4,
    x2: 509.3,
    y2: 236.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g219",
    x1: 471.8,
    y1: 334,
    x2: 510,
    y2: 235.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g220",
    x1: 469.3,
    y1: 326.1,
    x2: 510.3,
    y2: 233.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f5c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2c2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g221",
    x1: 466.9,
    y1: 317.7,
    x2: 509.9,
    y2: 232.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4b4849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2728"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g222",
    x1: 464.3,
    y1: 308.8,
    x2: 508.8,
    y2: 230.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272324"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g223",
    x1: 455.2,
    y1: 354.4,
    x2: 433,
    y2: 403.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g224",
    x1: 430.4,
    y1: 380.6,
    x2: 438.3,
    y2: 354.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g225",
    x1: 472.6,
    y1: 370.8,
    x2: 414.4,
    y2: 369.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g226",
    x1: 429.2,
    y1: 360.1,
    x2: 484.3,
    y2: 360.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g227",
    x1: 496.4,
    y1: 422.2,
    x2: 426.9,
    y2: 301.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6c6c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#bcbcd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9d9eb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g228",
    x1: 427,
    y1: 385.8,
    x2: 427.6,
    y2: 375.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6c6c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbcd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g229",
    x1: 436.1,
    y1: 395,
    x2: 442.2,
    y2: 353.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g230",
    cx: 541.4,
    cy: 315.1,
    r: 27.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4916a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g231",
    x1: 469.4,
    y1: 345.5,
    x2: 465.5,
    y2: 399.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g232",
    x1: 455.2,
    y1: 377.3,
    x2: 433,
    y2: 353.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g233",
    x1: 435.6,
    y1: 335.4,
    x2: 530.7,
    y2: 372.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g234",
    cx: 448.8,
    cy: 384.9,
    r: 12.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g235",
    cx: 464.5,
    cy: 359.2,
    r: 30,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g236",
    x1: 259.4,
    y1: 229.4,
    x2: 182.8,
    y2: 229.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g237",
    x1: 266.6,
    y1: 49.9,
    x2: 155.3,
    y2: 10.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g238",
    x1: 284.7,
    y1: 225.2,
    x2: 201,
    y2: 225.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g239",
    x1: 234.3,
    y1: 383.5,
    x2: 331.3,
    y2: 219.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4c9de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655cd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g240",
    x1: 379.6,
    y1: 254.1,
    x2: 118.7,
    y2: 17.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g241",
    cx: 155.9,
    cy: 222.6,
    r: 64.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g242",
    x1: 388.6,
    y1: 497,
    x2: 438.6,
    y2: 497,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g243",
    cx: 415,
    cy: 508.9,
    r: 10.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g244",
    cx: 409.9,
    cy: 512.4,
    r: 8.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g245",
    cx: 413.6,
    cy: 507.8,
    r: 17.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g246",
    cx: 423.6,
    cy: 513.2,
    r: 12.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g247",
    cx: 409.7,
    cy: 513.6,
    r: 16.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g248",
    x1: 496.1,
    y1: 514.9,
    x2: 446,
    y2: 514.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g249",
    cx: 471.1,
    cy: 525.8,
    r: 17.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g250",
    cx: 469.7,
    cy: 526.9,
    r: 10.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g251",
    cx: 474.8,
    cy: 530.4,
    r: 8.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g252",
    cx: 461.1,
    cy: 531.2,
    r: 12.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g253",
    cx: 475,
    cy: 531.6,
    r: 16.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g254",
    x1: 481.8,
    y1: 516.8,
    x2: 517.4,
    y2: 516.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g255",
    cx: 499.3,
    cy: 533,
    r: 5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g256",
    cx: 501,
    cy: 531.9,
    r: 10,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g257",
    cx: 500.9,
    cy: 528.2,
    r: 13.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g258",
    cx: 497.5,
    cy: 531.9,
    r: 8.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g259",
    cx: 497.5,
    cy: 534.3,
    r: 14.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g260",
    cx: 47.4,
    cy: 490.4,
    r: 17.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeeef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d1d3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9da7b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g261",
    x1: 98.3,
    y1: 413.9,
    x2: 75.1,
    y2: 401.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7d3adf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g262",
    cx: 52.8,
    cy: 486.7,
    r: 36,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g263",
    x1: 72.9,
    y1: 389,
    x2: 80.5,
    y2: 420,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56ef4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g264",
    x1: 102.6,
    y1: 395,
    x2: 88.8,
    y2: 387.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b4b8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g265",
    cx: 44,
    cy: 511.4,
    r: 14.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeeef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d1d3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9da7b3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g266",
    cx: 124.6,
    cy: 297.4,
    r: 76.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f6f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g267",
    x1: 61.3,
    y1: 31,
    x2: -122.4,
    y2: 343.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g268",
    x1: 289.7,
    y1: 228.1,
    x2: 186.3,
    y2: 228.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g269",
    x1: 299.4,
    y1: -14.3,
    x2: 149.2,
    y2: -67.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g270",
    x1: 289.7,
    y1: 222.4,
    x2: 176.6,
    y2: 222.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g271",
    x1: 255.8,
    y1: 436,
    x2: 386.7,
    y2: 215.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4c9de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655cd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g272",
    x1: 452,
    y1: 261.3,
    x2: 99.8,
    y2: -57.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g273",
    cx: 150,
    cy: 218.9,
    r: 87.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g274",
    x1: 279.9,
    y1: 296.1,
    x2: 273.7,
    y2: 490.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g275",
    x1: 73.8,
    y1: 165.9,
    x2: -42.6,
    y2: 373.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g276",
    cx: 157.7,
    cy: 292.5,
    r: 89.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b0fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363885"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g277",
    cx: 158.1,
    cy: 293.2,
    r: 89.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g278",
    x1: 54.3,
    y1: 151.7,
    x2: -41.7,
    y2: 335.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b4b8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g279",
    x1: 127.3,
    y1: 470.4,
    x2: -26.2,
    y2: 350.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cacdeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g280",
    cx: 118.1,
    cy: 262.5,
    r: 71.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g281",
    cx: 160.7,
    cy: 278.2,
    r: 49,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g282",
    cx: 160.6,
    cy: 376.4,
    r: 16.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d0951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g283",
    cx: 81.5,
    cy: 358.5,
    r: 16.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g284",
    cx: 123.1,
    cy: 253.1,
    r: 16.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g285",
    cx: 185,
    cy: 273.1,
    r: 37.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dc3daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g286",
    cx: 99.3,
    cy: 360,
    r: 37.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#271273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:.2;fill:url(#g1)}.b{opacity:0}.c{opacity:.1}.d{opacity:.2}.e{opacity:.3}.f{opacity:.4}.g{opacity:.5}.h{opacity:.6}.i{opacity:.7}.j{opacity:.8}.k{opacity:.9}.l{fill:url(#g2)}.m{fill:url(#g3)}.n{opacity:.8;mix-blend-mode:multiply;fill:url(#g4)}.o{opacity:.6;mix-blend-mode:screen;fill:url(#g5)}.p{opacity:.3;mix-blend-mode:color-dodge;fill:url(#g6)}.q{fill:url(#g7)}.r{fill:url(#g8)}.s{mix-blend-mode:multiply;fill:#bcbec0}.t{fill:url(#g9)}.u{opacity:.6;mix-blend-mode:screen;fill:url(#g10)}.v{fill:url(#g11)}.w{opacity:.6;mix-blend-mode:screen;fill:url(#g12)}.x{fill:url(#g13)}.y{fill:url(#g14)}.z{fill:url(#g15)}.A{fill:url(#g16)}.B{fill:url(#g17)}.C{mix-blend-mode:color-dodge;fill:url(#g18)}.D{opacity:.6;mix-blend-mode:screen;fill:url(#g19)}.E{fill:url(#g20)}.F{fill:url(#g21)}.G{fill:url(#g22)}.H{fill:url(#g23)}.I{mix-blend-mode:multiply;fill:url(#g24)}.J{fill:url(#g25)}.K{opacity:.9;fill:url(#g26)}.L{fill:url(#g27)}.M{fill:url(#g28)}.N{fill:url(#g29)}.O{fill:url(#g30)}.P{fill:url(#g31)}.Q{fill:#fdd65b}.R{fill:url(#g32)}.S{mix-blend-mode:screen;fill:url(#g33)}.T{fill:url(#g34)}.U{mix-blend-mode:screen;fill:url(#g35)}.V{mix-blend-mode:multiply;fill:url(#g36)}.W{mix-blend-mode:color-dodge;fill:url(#g37)}.X{mix-blend-mode:color-dodge;fill:url(#g38)}.Y{fill:url(#g39)}.Z{fill:url(#g40)}.a0{mix-blend-mode:color-dodge;fill:url(#g41)}.a1{mix-blend-mode:multiply;fill:url(#g42)}.a2{fill:url(#g43)}.a3{fill:url(#g44)}.a4{fill:url(#g45)}.a5{fill:url(#g46)}.a6{fill:url(#g47)}.a7{mix-blend-mode:screen;fill:url(#g48)}.a8{fill:url(#g49)}.a9{mix-blend-mode:screen;fill:url(#g50)}.aa{mix-blend-mode:multiply;fill:url(#g51)}.ab{mix-blend-mode:color-dodge;fill:url(#g52)}.ac{mix-blend-mode:color-dodge;fill:url(#g53)}.ad{fill:url(#g54)}.ae{fill:url(#g55)}.af{mix-blend-mode:color-dodge;fill:url(#g56)}.ag{opacity:.9;fill:url(#g57)}.ah{opacity:.9;fill:url(#g58)}.ai{mix-blend-mode:color-dodge;fill:url(#g59)}.aj{fill:url(#g60)}.ak{mix-blend-mode:color-dodge;fill:url(#g61)}.al{mix-blend-mode:multiply;fill:url(#g62)}.am{fill:url(#g63)}.an{opacity:.9;fill:url(#g64)}.ao{opacity:.9;fill:url(#g65)}.ap{mix-blend-mode:color-dodge;fill:url(#g66)}.aq{fill:url(#g67)}.ar{opacity:.9;fill:url(#g68)}.as{opacity:.2;fill:url(#g69)}.at{opacity:.2;fill:url(#g70)}.au{opacity:.2;fill:url(#g71)}.av{opacity:.9;fill:url(#g72)}.aw{mix-blend-mode:color-dodge;fill:url(#g73)}.ax{opacity:.8;mix-blend-mode:color-dodge;fill:url(#g74)}.ay{opacity:.5;mix-blend-mode:color-dodge;fill:url(#g75)}.az{opacity:.7;mix-blend-mode:screen;fill:url(#g76)}.aA{fill:url(#g77)}.aB{fill:url(#g78)}.aC{fill:url(#g79)}.aD{fill:url(#g80)}.aE{fill:url(#g81)}.aF{mix-blend-mode:screen;fill:url(#g82)}.aG{fill:url(#g83)}.aH{mix-blend-mode:screen;fill:url(#g84)}.aI{mix-blend-mode:multiply;fill:url(#g85)}.aJ{mix-blend-mode:color-dodge;fill:url(#g86)}.aK{mix-blend-mode:color-dodge;fill:url(#g87)}.aL{fill:url(#g88)}.aM{fill:url(#g89)}.aN{mix-blend-mode:color-dodge;fill:url(#g90)}.aO{fill:url(#g91)}.aP{fill:url(#g92)}.aQ{fill:url(#g93)}.aR{fill:url(#g94)}.aS{fill:url(#g95)}.aT{mix-blend-mode:screen;fill:url(#g96)}.aU{fill:url(#g97)}.aV{mix-blend-mode:screen;fill:url(#g98)}.aW{mix-blend-mode:multiply;fill:url(#g99)}.aX{mix-blend-mode:color-dodge;fill:url(#g100)}.aY{mix-blend-mode:color-dodge;fill:url(#g101)}.aZ{fill:url(#g102)}.b0{fill:url(#g103)}.b1{mix-blend-mode:color-dodge;fill:url(#g104)}.b2{opacity:.3;mix-blend-mode:multiply;fill:url(#g105)}.b3{opacity:0;fill:url(#g106)}.b4{opacity:.1;fill:url(#g107)}.b5{opacity:.2;fill:url(#g108)}.b6{opacity:.3;fill:url(#g109)}.b7{opacity:.4;fill:url(#g110)}.b8{opacity:.5;fill:url(#g111)}.b9{opacity:.5;fill:url(#g112)}.ba{opacity:.6;fill:url(#g113)}.bb{opacity:.7;fill:url(#g114)}.bc{opacity:.8;fill:url(#g115)}.bd{opacity:.9;fill:url(#g116)}.be{fill:url(#g117)}.bf{opacity:.8;fill:url(#g118)}.bg{mix-blend-mode:color-dodge;fill:url(#g119)}.bh{fill:url(#g120)}.bi{fill:url(#g121)}.bj{fill:url(#g122)}.bk{fill:url(#g123)}.bl{fill:url(#g124)}.bm{fill:url(#g125)}.bn{fill:url(#g126)}.bo{fill:url(#g127)}.bp{fill:url(#g128)}.bq{fill:#fff}.br{fill:url(#g129)}.bs{fill:#4b61b8}.bt{fill:url(#g130)}.bu{fill:url(#g131)}.bv{fill:url(#g132)}.bw{fill:url(#g133)}.bx{fill:url(#g134)}.by{fill:url(#g135)}.bz{fill:url(#g136)}.bA{mix-blend-mode:multiply;fill:url(#g137)}.bB{mix-blend-mode:color-dodge;fill:url(#g138)}.bC{fill:url(#g139)}.bD{fill:url(#g140)}.bE{fill:url(#g141)}.bF{mix-blend-mode:multiply;fill:url(#g142)}.bG{mix-blend-mode:color-dodge;fill:url(#g143)}.bH{fill:url(#g144)}.bI{fill:url(#g145)}.bJ{fill:url(#g146)}.bK{mix-blend-mode:multiply;fill:url(#g147)}.bL{mix-blend-mode:color-dodge;fill:url(#g148)}.bM{fill:url(#g149)}.bN{fill:url(#g150)}.bO{fill:url(#g151)}.bP{mix-blend-mode:multiply;fill:url(#g152)}.bQ{mix-blend-mode:color-dodge;fill:url(#g153)}.bR{fill:url(#g154)}.bS{fill:url(#g155)}.bT{fill:url(#g156)}.bU{mix-blend-mode:multiply;fill:url(#g157)}.bV{mix-blend-mode:color-dodge;fill:url(#g158)}.bW{opacity:0;fill:url(#g159)}.bX{opacity:.1;fill:url(#g160)}.bY{opacity:.2;fill:url(#g161)}.bZ{opacity:.3;fill:url(#g162)}.c0{opacity:.4;fill:url(#g163)}.c1{opacity:.5;fill:url(#g164)}.c2{opacity:.5;fill:url(#g165)}.c3{opacity:.6;fill:url(#g166)}.c4{opacity:.7;fill:url(#g167)}.c5{opacity:.8;fill:url(#g168)}.c6{opacity:.9;fill:url(#g169)}.c7{fill:url(#g170)}.c8{opacity:.8;fill:url(#g171)}.c9{mix-blend-mode:color-dodge;fill:url(#g172)}.ca{fill:url(#g173)}.cb{fill:url(#g174)}.cc{fill:url(#g175)}.cd{fill:url(#g176)}.ce{fill:url(#g177)}.cf{fill:url(#g178)}.cg{fill:url(#g179)}.ch{fill:url(#g180)}.ci{fill:url(#g181)}.cj{fill:url(#g182)}.ck{fill:url(#g183)}.cl{fill:url(#g184)}.cm{fill:url(#g185)}.cn{fill:url(#g186)}.co{fill:url(#g187)}.cp{fill:url(#g188)}.cq{fill:url(#g189)}.cr{fill:url(#g190)}.cs{fill:url(#g191)}.ct{fill:url(#g192)}.cu{fill:url(#g193)}.cv{fill:url(#g194)}.cw{fill:url(#g195)}.cx{fill:url(#g196)}.cy{fill:url(#g197)}.cz{fill:url(#g198)}.cA{fill:url(#g199)}.cB{fill:url(#g200)}.cC{fill:url(#g201)}.cD{fill:url(#g202)}.cE{fill:url(#g203)}.cF{fill:url(#g204)}.cG{fill:url(#g205)}.cH{fill:url(#g206)}.cI{fill:url(#g207)}.cJ{fill:url(#g208)}.cK{fill:url(#g209)}.cL{fill:url(#g210)}.cM{fill:url(#g211)}.cN{opacity:.1;mix-blend-mode:multiply;fill:url(#g212)}.cO{opacity:.1;mix-blend-mode:multiply;fill:url(#g213)}.cP{opacity:.1;mix-blend-mode:multiply;fill:url(#g214)}.cQ{opacity:.1;mix-blend-mode:multiply;fill:url(#g215)}.cR{opacity:.1;mix-blend-mode:multiply;fill:url(#g216)}.cS{opacity:.1;mix-blend-mode:multiply;fill:url(#g217)}.cT{opacity:.2;mix-blend-mode:multiply;fill:url(#g218)}.cU{opacity:.2;mix-blend-mode:multiply;fill:url(#g219)}.cV{opacity:.2;mix-blend-mode:multiply;fill:url(#g220)}.cW{opacity:.2;mix-blend-mode:multiply;fill:url(#g221)}.cX{opacity:.2;mix-blend-mode:multiply;fill:url(#g222)}.cY{opacity:.2;mix-blend-mode:multiply;fill:#231f20}.cZ{fill:url(#g223)}.d0{fill:url(#g224)}.d1{fill:url(#g225)}.d2{fill:url(#g226)}.d3{fill:url(#g227)}.d4{fill:url(#g228)}.d5{fill:url(#g229)}.d6{mix-blend-mode:color-dodge;fill:url(#g230)}.d7{fill:url(#g231)}.d8{fill:url(#g232)}.d9{fill:url(#g233)}.da{mix-blend-mode:color-dodge;fill:url(#g234)}.db{mix-blend-mode:color-dodge;fill:url(#g235)}.dc{fill:url(#g236)}.dd{fill:url(#g237)}.de{fill:url(#g238)}.df{fill:url(#g239)}.dg{fill:url(#g240)}.dh{mix-blend-mode:color-dodge;fill:url(#g241)}.di{mix-blend-mode:multiply;fill:#d1d3d4}.dj{fill:url(#g242)}.dk{fill:url(#g243)}.dl{fill:url(#g244)}.dm{fill:url(#g245)}.dn{fill:url(#g246)}.do{fill:url(#g247)}.dp{fill:url(#g248)}.dq{fill:url(#g249)}.dr{fill:url(#g250)}.ds{fill:url(#g251)}.dt{fill:url(#g252)}.du{fill:url(#g253)}.dv{fill:url(#g254)}.dw{fill:url(#g255)}.dx{fill:url(#g256)}.dy{fill:url(#g257)}.dz{fill:url(#g258)}.dA{fill:url(#g259)}.dB{fill:url(#g260)}.dC{fill:url(#g261)}.dD{mix-blend-mode:color-dodge;fill:url(#g262)}.dE{fill:url(#g263)}.dF{fill:url(#g264)}.dG{opacity:.2;fill:url(#g265)}.dH{opacity:.3;mix-blend-mode:multiply;fill:url(#g266)}.dI{fill:url(#g267)}.dJ{fill:url(#g268)}.dK{fill:url(#g269)}.dL{fill:url(#g270)}.dM{fill:url(#g271)}.dN{fill:url(#g272)}.dO{mix-blend-mode:color-dodge;fill:url(#g273)}.dP{fill:url(#g274)}.dQ{fill:url(#g275)}.dR{opacity:.5;mix-blend-mode:screen;fill:url(#g276)}.dS{fill:url(#g277)}.dT{fill:url(#g278)}.dU{fill:url(#g279)}.dV{mix-blend-mode:screen;fill:url(#g280)}.dW{opacity:.5;mix-blend-mode:screen;fill:url(#g281)}.dX{mix-blend-mode:color-dodge;fill:url(#g282)}.dY{mix-blend-mode:color-dodge;fill:url(#g283)}.dZ{mix-blend-mode:color-dodge;fill:url(#g284)}.e0{opacity:.8;mix-blend-mode:color-dodge;fill:url(#g285)}.e1{opacity:.8;mix-blend-mode:color-dodge;fill:url(#g286)}.e2{mix-blend-mode:color-dodge;fill:#27043d}.e3{fill:#27043d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m571.9 411.7c0 3.2-2.3 6.5-6.8 9.1l-65.1 62.1c-8.2 4.8-20.7 5.3-27.8 1.2l-118.5-68.8c-3.5-2-5-4.7-4.8-7.5q0 0.2 0 0.5c0 0.1 0 8.8 0 8.9 0 2.6 1.6 5 4.8 6.9l118.5 68.8c7.1 4.1 19.6 3.6 27.8-1.2l65.1-62.1c4.6-2.7 6.9-6.1 6.8-9.3 0-0.5 0.1-6.4 0-8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m484.2 491.7c-6.5 0-12.4-1.4-17-4.1l-118.5-68.8c-6.2-3.6-9.8-9.3-9.8-15.6 0-6.9 4.3-13.4 11.8-17.7l104-40c5.9-3.4 13.2-5.2 20.7-5.2 6.5 0 12.4 1.4 17.1 4.1l79.6 46.6c6.2 3.6 9.8 9.3 9.8 15.6 0 6.9-4.3 13.4-11.8 17.7l-65.1 62.2c-5.9 3.4-13.3 5.2-20.8 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m351.2 386.3l103.9-40c5.9-3.4 13.3-5.2 20.7-5.1 3.1 0 6.2 0.4 9 1.1 2.6 0.7 5.7 2 7.8 3.2l76.9 45.1c0.1 0 2.3 1.3 2.3 1.3 6.1 3.7 8.9 9.4 8.6 15.5-0.4 6.3-5.1 13.3-11.9 17.3l-64 61c-5.7 3.3-12.9 5.1-20.2 5.1-6.3 0-12.1-1.3-16.7-4l-118.4-68.8c-6-3.4-9.4-8.8-9.4-14.8 0.1-6.6 4.2-12.7 11.4-16.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m351.6 387.1l104-40c5.8-3.4 13.2-5.1 20.5-5 3.2 0.1 6.2 0.6 8.9 1.3 2.4 0.6 5.9 2.2 7.8 3.3l76.5 44.8c0.1 0.1 2.2 1.3 2.3 1.4 5.9 3.7 7.9 9.3 7.2 15.4-0.6 5.6-5.8 13.2-12 16.7l-62.7 59.9c-5.6 3.2-12.7 5-19.8 5-6.1 0-11.8-1.3-16.2-3.8l-118.5-68.8c-5.7-3.4-8.9-8.5-8.9-14.2 0.1-6.2 4-12 10.9-16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m352.1 387.9l103.9-40c5.8-3.4 13.3-5.1 20.5-4.9 3.1 0.1 6.1 0.7 8.8 1.5 2.1 0.6 6 2.3 7.7 3.3l76.1 44.6c0.2 0.1 2 1.2 2.2 1.4 5.8 3.7 7 9.3 6 15.3-0.8 5-6.6 13.1-12.1 16.2l-61.6 58.8c-5.5 3.2-12.3 4.9-19.2 4.9-6 0.1-11.6-1.2-15.9-3.7l-118.4-68.8c-5.5-3.2-8.5-8.1-8.5-13.5 0.1-5.8 3.9-11.3 10.5-15.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m352.5 388.7l104-40c5.8-3.4 13.2-5 20.3-4.7 3.2 0.1 6.1 0.8 8.8 1.5 1.8 0.6 6.1 2.6 7.6 3.5l75.6 44.3c0.3 0.2 2 1.2 2.2 1.4 5.7 3.8 7.4 9.7 4.8 15.2 0 4.4-7.5 13-12.2 15.8l-60.4 57.6c-5.4 3.1-12.1 4.8-18.8 4.8-5.8 0.1-11.2-1.2-15.4-3.6l-118.5-68.8c-5.2-3-8.1-7.7-8-12.7 0.2-5.5 3.7-10.7 10-14.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m353 389.4l103.9-40c5.8-3.3 13.3-4.9 20.3-4.5 3.1 0.2 6 0.9 8.6 1.7 1.6 0.5 6.3 2.8 7.6 3.5l75.2 44.1c0.3 0.2 1.9 1.2 2.2 1.4 5.5 3.9 6.8 9.8 3.5 15.2 0 3.7-8.3 12.9-12.3 15.2l-59.3 56.6c-5.2 3-11.7 4.6-18.2 4.6-5.7 0.1-11-1.1-15.1-3.5l-118.4-68.8c-5-2.9-7.7-7.2-7.5-12 0.1-5.1 3.5-10 9.5-13.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m353.4 390.2l104-40c5.7-3.3 13.2-4.8 20.1-4.4 3.2 0.2 6 1 8.6 1.9 1.3 0.4 6.4 3 7.4 3.6l74.8 43.8c0.5 0.3 1.9 1.1 2.2 1.4 5.4 4 6.2 9.9 2.2 15.1 0 3.1-9 12.8-12.4 14.8l-58 55.4c-5.1 2.9-11.5 4.5-17.8 4.5-5.5 0.1-10.7-1.1-14.6-3.4l-118.5-68.8c-4.7-2.7-7.2-6.8-7-11.3 0.1-4.7 3.3-9.3 9-12.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m353.9 391l103.9-40c5.8-3.3 13.2-4.8 20.1-4.3 3.1 0.3 5.9 1.2 8.5 2 1 0.4 6.5 3.2 7.3 3.7l74.4 43.6c0.5 0.3 1.8 1.1 2.1 1.4 5.3 4 5.7 10 1 15 0 2.5-9.8 12.7-12.5 14.3l-56.9 54.3c-4.9 2.8-11.1 4.4-17.2 4.4-5.4 0.1-10.4-1-14.3-3.2l-118.4-68.9c-4.5-2.6-6.8-6.4-6.6-10.5 0.2-4.4 3.2-8.7 8.6-11.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m354.3 391.8l104-40c5.7-3.3 13.2-4.7 20-4.1 3.1 0.2 5.8 1.2 8.4 2.1 0.7 0.3 6.6 3.4 7.2 3.8l73.9 43.3c0.6 0.4 1.7 1.1 2.2 1.5 5.2 4 5 10-0.3 14.8 0 1.9-10.6 12.7-12.6 13.8l-55.8 53.2c-4.7 2.8-10.8 4.3-16.7 4.3-5.2 0.1-10.1-1-13.8-3.1l-118.5-68.8c-4.2-2.5-6.4-6.1-6.1-9.9 0.2-4 3-8 8.1-10.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m354.8 392.6l103.9-40c5.7-3.3 13.2-4.7 19.9-4 3.1 0.3 5.8 1.3 8.3 2.3 0.6 0.1 6.8 3.6 7.2 3.9l73.5 43c0.6 0.4 1.6 1 2.1 1.5 5.1 4.1 4.5 10.1-1.5 14.8 0 1.2-11.4 12.5-12.8 13.3l-54.5 52c-4.6 2.7-10.5 4.1-16.2 4.2-5.1 0.1-9.9-0.9-13.4-3l-118.5-68.8c-4-2.3-6-5.7-5.7-9.2 0.3-3.6 2.9-7.3 7.7-10z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m355.2 393.4l104-40c5.6-3.3 13.2-4.6 19.8-3.9 3 0.4 5.7 1.5 8.2 2.4 0.3 0.1 6.8 3.9 7.1 4l73.1 42.8c0.7 0.4 1.5 1 2.1 1.5 4.9 4.1 3.8 10.3-2.9 14.7 0 0.6-12.1 12.4-12.8 12.8l-53.4 50.9c-4.5 2.6-10.2 4-15.7 4.1-4.9 0.1-9.5-0.9-13-2.9l-118.5-68.8c-3.7-2.2-5.5-5.2-5.2-8.4 0.3-3.3 2.8-6.7 7.2-9.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m472.2 479l-118.5-68.8c-7.2-4.1-6.3-11.3 2-16.1l104-40c8.2-4.7 20.7-5.2 27.8-1.1l79.6 46.6c7.2 4.2 6.3 11.4-2 16.1l-65.1 62.2c-8.2 4.7-20.7 5.2-27.8 1.1z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m472.2 478.9l-118.5-68.9c-3.2-1.8-4.8-4.2-4.8-6.8 0-0.1 0-8.9 0-9 0-3.1 2.3 2.3 6.8-0.2l104-40c8.2-4.8 20.7-5.3 27.8-1.2l79.6 46.7c2.4 1.3 4.1-4.5 4.7-2.6 0.3 0.6 0.1 8.8 0.1 9.4 0.1 3.2-2.2 6.6-6.8 9.2l-65.1 62.2c-8.2 4.8-20.7 5.3-27.8 1.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m472.2 470.1l-118.5-68.8c-7.2-4.2-6.3-11.4 2-16.1l104-40c8.2-4.8 20.7-5.3 27.8-1.2l79.6 46.7c7.2 4.1 6.3 11.3-2 16.1l-65.1 62.1c-8.2 4.8-20.7 5.3-27.8 1.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m567.1 390.7l-79.6-46.7c-7.1-4.1-19.6-3.6-27.8 1.2l-52.4 20.1q0.7 0.6 1.6 1.2l118.5 68.8c1.6 0.9 3.5 1.6 5.6 2.1l32.1-30.6c8.3-4.8 9.2-12 2-16.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m565.1 405.3l-65.1 62.1c-8.2 4.8-20.7 5.3-27.8 1.2l-118.5-68.8c-3-1.7-4.5-4-4.8-6.4-0.4 3 1.2 5.8 4.8 7.9l118.5 68.8c7.1 4.1 19.6 3.6 27.8-1.2l65.1-62.1c4.8-2.8 7.1-6.4 6.8-9.8-0.4 2.9-2.7 5.9-6.8 8.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m486.9 470c-7.9 16.8-48 14.6-89.5-5-41.5-19.6-68.7-49.1-60.8-65.9 8-16.8 48-14.6 89.5 5 41.5 19.6 68.7 49.1 60.8 65.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m626.9 470.5l-290.9-168.2c-14.9-8.6-27-31.6-27-51.4v-222.6c0-19.8 12.1-28.9 27-20.3l290.9 168.1c14.9 8.6 27 31.6 27 51.4v222.6c0 19.8-12.1 28.9-27 20.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m630.4 455l-286.9-165.8c-11.9-7.6-19.3-22.8-19.3-38.3v-224c0-3.7 4-6 7.2-4.2q0.5 0.4 0.8 0.5l287.2 166c14.2 8.2 19.4 22.8 19.4 38.4v223.2c0 4-4.3 6.5-7.8 4.5q-0.4-0.2-0.6-0.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s",
    d: "m638.8 227.6v223.2c0 4-4.3 6.5-7.8 4.5q-0.4-0.2-0.6-0.3l-286.9-165.8c-11.9-7.6-19.3-22.8-19.3-38.3v-224c0-3.7 4-6 7.2-4.2q0.5 0.4 0.8 0.5l287.2 166c14.2 8.2 19.4 22.8 19.4 38.4zm-3.1-0.1c0-11.6-3.1-27.2-17.8-35.7l-288.1-166.5q-0.4-0.2-0.9-0.2c-0.8 0-1.7 0.7-1.7 1.8v224c0 14.8 7 28.8 17.9 35.7l287.4 166.1q0.5 0.3 1.1 0.3c1 0 2.1-0.8 2.1-2.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m634.6 172l-291-168.1c-5.9-3.4-11.3-4-15.8-2.3-0.5 0.2-8 4.2-8.6 4.5q0 0 0 0c4.6-2.2 10.4-1.8 16.8 1.9l290.9 168.1c14.9 8.6 27 31.6 27 51.4v222.6c0 12.4-4.7 20.6-11.9 22.9 0.6 0 1.3-0.2 2.4-0.8 0.3-0.2 8.5-4.8 8.8-5 5.1-3.6 8.3-11 8.3-21.2v-222.5c0-19.8-12-42.9-26.9-51.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m628.2 175.4l-290.9-168.1c-6.1-3.5-11.7-4-16.3-2.1 3.9-0.6 8.3 0.4 13 3.1l291 168.1c14.9 8.6 26.9 31.6 26.9 51.5v222.5c0 11.7-4.2 19.6-10.7 22.4 8.3-1.3 14-9.8 14-23.4v-222.5c0-19.8-12.1-42.9-27-51.5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m100.1 478.8c3.7 0 7.1-0.8 9.7-2.3l59.3-33.8 59.3-33.7c3.6-2.1 5.6-5.3 5.6-8.9 0-4-2.5-7.7-6.7-10.2l-38.8-21.8c-3.4-1.9-7.6-3-11.9-3-3.7 0-7.1 0.8-9.8 2.3l-59.2 33.8-59.3 33.7c-3.6 2.1-5.6 5.3-5.6 8.9 0 4 2.4 7.7 6.7 10.2l38.8 21.8c3.4 1.9 7.6 3 11.9 3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m226.2 390.8l-10.5-5.9c-0.4-0.3-20.2-11-20.6-10.8l-6.7-3.3c-3.1-1.8-7.6-2.4-11.5-2.4-3.4 0-7 1.1-9.4 2.5l-47.5 27-10.1 5.8-57.6 32.8c-1.8 1-3.6 2.7-4.4 4.3-0.8 1.3-1.2 2.7-1.2 4.2-0.2 3.8 2.2 7.4 6.4 9.8l10.5 5.9c0.5 0.3 20.2 11 20.6 10.8l6.7 3.3c3.1 1.8 7.6 2.4 11.5 2.4 3.4 0 7-1.1 9.4-2.5l47.5-27 10.1-5.8 57.6-32.8c1.9-1 3.6-2.7 4.5-4.3 0.7-1.3 1.1-2.7 1.2-4.2 0.1-3.8-2.3-7.4-6.5-9.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m225.2 391.6l-10.3-5.7c-0.8-0.5-19.3-10.2-20.1-9.7l-6.5-2.8c-2.8-1.6-7.6-1.7-11.1-1.7-3 0-6.9 1.3-9.1 2.6l-46.1 26.3-9.7 5.6-56 31.8c-1.6 1-3.5 2.7-4.4 4.2-0.7 1.2-1.2 2.5-1.3 3.9-0.2 3.7 2 7.2 6.2 9.6l10.2 5.7c0.9 0.5 19.4 10.2 20.1 9.8l6.6 2.7c2.7 1.6 7.5 1.7 11 1.7 3.1 0 6.9-1.3 9.1-2.6l46.1-26.3 9.8-5.6 55.9-31.8c1.7-1 3.6-2.7 4.4-4.2 0.7-1.2 1.2-2.5 1.3-3.9 0.2-3.7-2-7.2-6.1-9.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m224.1 392.4l-9.9-5.4c-1.3-0.8-18.6-9.4-19.7-8.8l-6.3-2.1c-2.5-1.4-7.6-1-10.7-1-2.7 0-6.8 1.5-8.7 2.6l-44.7 25.6-9.5 5.4-54.2 30.9c-1.5 0.9-3.6 2.7-4.4 3.9-0.7 1.2-1.3 2.5-1.4 3.8-0.3 3.5 1.8 6.9 5.9 9.3l9.9 5.4c1.3 0.8 18.5 9.5 19.6 8.8l6.4 2.1c2.4 1.4 7.5 1.1 10.6 1.1 2.7 0 6.8-1.6 8.8-2.7l44.7-25.5 9.5-5.4 54.2-31c1.5-0.9 3.6-2.6 4.3-3.9 0.8-1.2 1.3-2.4 1.4-3.8 0.4-3.5-1.7-6.9-5.8-9.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m223.1 393.3l-9.7-5.3c-1.7-1-17.7-8.6-19.2-7.7l-6.1-1.5c-2.2-1.3-7.5-0.4-10.3-0.4-2.3 0-6.7 1.8-8.4 2.8l-43.3 24.7-9.2 5.3-52.5 30c-1.3 0.7-3.6 2.6-4.3 3.7-0.7 1.1-1.3 2.3-1.5 3.6-0.4 3.3 1.5 6.7 5.5 9l9.7 5.2c1.7 1 17.7 8.6 19.2 7.8l6.1 1.5c2.2 1.2 7.5 0.3 10.2 0.3 2.4 0 6.8-1.7 8.4-2.7l43.4-24.8 9.1-5.2 52.6-30.1c1.3-0.7 3.6-2.6 4.3-3.6 0.7-1.2 1.3-2.4 1.5-3.6 0.4-3.4-1.6-6.7-5.5-9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m222 394.1l-9.4-5c-2.1-1.3-16.8-7.8-18.7-6.8l-5.9-0.9c-1.9-1-7.5 0.3-9.8 0.3-2.1 0-6.7 2-8.1 2.9l-41.9 24-8.9 5-50.9 29.2c-1.1 0.6-3.6 2.5-4.2 3.4-0.8 1.1-1.4 2.2-1.6 3.4-0.6 3.2 1.3 6.5 5.2 8.7l9.4 5.1c2.1 1.2 16.8 7.8 18.7 6.7l5.9 0.9c1.9 1.1 7.5-0.3 9.9-0.3 2 0 6.6-2 8-2.8l42-24 8.8-5.1 50.9-29.1c1.1-0.7 3.6-2.6 4.2-3.5 0.8-1.1 1.4-2.2 1.6-3.4 0.6-3.2-1.3-6.4-5.2-8.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m221 394.9l-9.1-4.8c-2.6-1.5-16.1-7-18.3-5.7l-5.7-0.3c-1.6-0.9-7.5 0.9-9.4 0.9-1.7 0-6.6 2.3-7.8 3l-40.5 23.2-8.6 4.9-49.2 28.2c-0.9 0.6-3.6 2.5-4.1 3.3-0.8 1.1-1.5 2-1.8 3.2-0.6 3 1.1 6.2 5 8.4l9.1 4.8c2.6 1.5 16 7 18.2 5.8l5.8 0.3c1.5 0.8 7.4-1 9.4-1 1.7 0 6.5-2.3 7.7-3l40.5-23.2 8.6-4.9 49.2-28.2c0.9-0.5 3.6-2.5 4.2-3.2 0.7-1.1 1.4-2.1 1.7-3.2 0.6-3.1-1.1-6.2-4.9-8.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m219.9 395.8l-8.8-4.6c-3-1.8-15.2-6.2-17.8-4.7l-5.5 0.3c-1.2-0.8-7.5 1.6-9 1.6-1.4 0-6.4 2.5-7.4 3l-39.2 22.5-8.2 4.7-47.5 27.3c-0.8 0.4-3.7 2.5-4.1 3.1-0.8 1-1.6 1.9-1.9 2.9-0.7 2.9 0.9 6 4.7 8.2l8.8 4.6c3 1.7 15.1 6.2 17.7 4.7l5.6-0.3c1.2 0.7 7.4-1.6 9-1.6 1.3 0 6.4-2.5 7.4-3.1l39.1-22.4 8.3-4.8 47.5-27.2c0.7-0.5 3.6-2.5 4.1-3.1 0.8-1 1.5-1.9 1.8-3 0.8-2.9-0.8-6-4.6-8.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m218.9 396.6l-8.6-4.4c-3.4-2-14.3-5.4-17.3-3.7l-5.3 0.9c-0.9-0.5-7.4 2.3-8.6 2.3-1 0-6.3 2.8-7.1 3.2l-37.7 21.7-8 4.5-45.8 26.4c-0.6 0.3-3.8 2.3-4 2.8-1 0.8-1.7 1.8-2 2.8-0.9 2.7 0.6 5.7 4.3 7.9l8.6 4.3c3.4 2 14.3 5.5 17.3 3.7l5.3-0.9c0.9 0.6 7.4-2.2 8.6-2.2 1 0 6.3-2.8 7.1-3.2l37.7-21.7 8-4.6 45.8-26.3c0.6-0.3 3.8-2.4 4-2.8 1-0.9 1.7-1.8 2-2.8 0.9-2.7-0.7-5.8-4.3-7.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m217.8 397.4l-8.2-4.1c-3.9-2.3-13.6-4.7-16.9-2.7l-5.1 1.5c-0.6-0.4-7.4 2.9-8.2 2.9-0.7 0-6.2 3-6.7 3.3l-36.4 20.9-7.6 4.4-44.2 25.4c-0.4 0.2-3.8 2.3-4 2.7-1 0.7-1.7 1.6-2 2.5-1 2.6 0.4 5.5 4 7.6l8.3 4.2c3.8 2.2 13.5 4.6 16.8 2.7l5.1-1.5c0.6 0.3 7.4-2.9 8.2-2.9 0.7 0 6.2-3 6.7-3.3l36.4-20.9 7.6-4.5 44.2-25.4c0.4-0.2 3.8-2.3 4-2.6 1-0.7 1.7-1.6 2-2.6 1-2.5-0.4-5.5-4-7.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m216.8 398.3l-8-4c-4.3-2.5-12.7-3.8-16.4-1.7l-4.9 2.1c-0.3-0.1-7.4 3.6-7.8 3.6-0.3 0-6.1 3.3-6.4 3.4l-34.9 20.2-7.4 4.2-42.5 24.5c-0.2 0.1-3.8 2.3-3.9 2.4q-1.5 1.1-2.1 2.4c-1.2 2.4 0.1 5.3 3.7 7.3l8 4c4.2 2.4 12.6 3.8 16.3 1.6l5-2.1c0.3 0.2 7.3-3.6 7.7-3.6 0.4 0 6.2-3.2 6.4-3.3l35-20.2 7.3-4.2 42.5-24.5c0.2-0.1 3.8-2.3 3.9-2.4q1.6-1.1 2.2-2.4c1.1-2.4-0.2-5.3-3.7-7.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m113.5 468l51.7-29.8 51.6-29.9c4.1-2.3 3.6-6.5-1.1-9.2l-7.7-3.7c-4.7-2.8-11.8-3.1-15.9-0.7l-51.7 29.8-51.7 29.9c-4.1 2.3-3.6 6.5 1.2 9.2l7.6 3.7c4.8 2.8 11.9 3.1 16 0.7z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m106.3 562.7l92.7-53.6c10.4-6 18.9-22.2 18.9-36.2v-49.2c0-7.1 5.9-8.6 2.3-11.2-0.1-0.1-8.3-3.8-8.4-3.8-3.8-1.5-7.9-2.1-12.8 0.7l-92.7 53.5c-10.5 6.1-19 22.3-19 36.2v49.3c0 7.4 2.4 12.6 6.2 15.1 0.2 0.1 10.1 4.8 10.3 4.9 3.4 1.1-2.1-3.1 2.5-5.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m113.5 566l92.7-53.6c10.4-6 18.9-22.2 18.9-36.2v-49.2c0-13.9-8.5-20.3-18.9-14.3l-92.7 53.5c-10.5 6.1-19 22.3-19 36.2v49.2c0 14 8.5 20.4 19 14.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m115.1 566.9l92.7-53.6c10.5-6 19-22.2 19-36.2v-49.2c0-13.9-8.5-20.3-19-14.3l-92.7 53.5c-10.5 6.1-18.9 22.3-18.9 36.2v49.2c0 14 8.4 20.4 18.9 14.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m224.2 478.8v-49.5c0-12.3-7.4-17.9-16.6-12.6l-92.2 53.3c-9.2 5.2-16.6 19.5-16.6 31.7v49.5c0 12.2 7.4 17.8 16.6 12.5l92.2-53.2c9.2-5.3 16.6-19.5 16.6-31.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m220.5 480.3v-48.3c0-10.2-6.2-14.9-13.9-10.5l-90.3 52.1c-7.6 4.5-13.9 16.3-13.9 26.6v48.2c0 10.3 6.3 15 13.9 10.5l90.3-52.1c7.7-4.4 13.9-16.3 13.9-26.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m205.6 424.2c7.2-4.2 13.1-0.8 13.1 7.5v51c0 8.3-5.9 18.4-13.1 22.6l-88.2 50.9c-7.2 4.2-13.1 0.9-13.1-7.4v-51.1c0-8.3 5.9-18.4 13.1-22.6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m106.1 458.6l92.8-53.5c10.4-6.1 18.9-22.3 18.9-36.2v-247c0-7.1 5.8-8.6 2.3-11.2-0.1-0.1-8.3-3.8-8.4-3.8-3.8-1.5-7.9-2.1-12.8 0.7l-92.8 53.5c-10.4 6.1-18.9 22.3-18.9 36.2v247c0 7.4 2.4 12.7 6.2 15.1 0.2 0.1 10 4.8 10.3 4.9 3.4 1.1-2.1-3.1 2.4-5.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m107 161.4l92.7-53.5c5-2.9-87.6 55.2-87.6 55.2-10.4 6.1-18.9 22.3-18.9 36.2 0 0-5.1 252.7-5.1 245.3v-247c0-13.9 8.4-30.1 18.9-36.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m113.3 461.9l92.8-53.6c10.4-6 18.9-22.2 18.9-36.1v-247c0-13.9-8.5-20.3-18.9-14.3l-92.8 53.5c-10.4 6.1-18.9 22.3-18.9 36.2v247c0 13.9 8.5 20.3 18.9 14.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m115 462.8l92.7-53.6c10.5-6 19-22.2 19-36.1v-247c0-13.9-8.5-20.3-19-14.3l-92.7 53.5c-10.5 6.1-18.9 22.3-18.9 36.2v247c0 13.9 8.4 20.3 18.9 14.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m224.1 374.7v-247.3c0-12.2-7.5-17.8-16.6-12.5l-92.3 53.2c-9.1 5.3-16.6 19.5-16.6 31.8v247.2c0 12.2 7.5 17.9 16.6 12.6l92.3-53.3c9.1-5.3 16.6-19.5 16.6-31.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m220.4 376.2v-246c0-10.2-6.2-14.9-13.9-10.5l-90.3 52.1c-7.6 4.4-13.9 16.3-13.9 26.6v246c0 10.2 6.3 14.9 13.9 10.5l90.3-52.1c7.7-4.5 13.9-16.4 13.9-26.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m205.5 122.4c7.2-4.2 13-0.8 13 7.5v248.7c0 8.3-5.8 18.5-13 22.6l-88.2 50.9c-7.3 4.2-13.1 0.9-13.1-7.4v-248.8c0-8.3 5.8-18.4 13.1-22.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m384.4 469.3c0 24.4-42.8 44.2-95.6 44.2-52.8 0-95.6-19.8-95.6-44.2 0-24.5 42.8-44.3 95.6-44.3 52.8 0 95.6 19.8 95.6 44.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m276.4 417.7c-44.3 0-80.1 20.6-80 46.2l50.8 0.1c0-4.4 2.8-8.7 8.5-12 11.5-6.6 30.1-6.6 41.6 0.1 11.6 6.6 11.6 17.4 0.2 24l36 20.8q23.4-13.5 23.3-32.7c-0.1-25.6-36.1-46.4-80.4-46.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m247.2 403.8l-50.8-0.1v60.3h50.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m255.7 452c11.5-6.6 30.1-6.6 41.6 0.1 5.7 3.3 8.6 7.6 8.7 11.9v-59.9c0.1-4.4-2.8-8.8-8.7-12.2-11.5-6.7-30.1-6.7-41.6-0.1-5.6 3.3-8.5 7.5-8.5 11.8v60.4c0-4.3 2.8-8.7 8.5-12z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m307 454.3h-59.9v8.5q0 0.1 0 0.2c0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5q0-0.1 0-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m247.1 461.7v0.2q0-0.1 0-0.2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m277 478.6c-16.5 0-29.9-7.8-29.9-17.4v1.6q0 0.1 0 0.2c0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5q0-0.1 0-0.2v-1.6c0 9.6-13.4 17.4-30 17.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m307 461.9v-0.2q0 0.1 0 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m286.2 479.7q0.5-0.1 0.9-0.2v-22.2h-0.9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m290 478.8q0.4-0.1 0.8-0.3v-21.2h-0.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m293.8 477.5q0.4-0.1 0.8-0.3v-19.9h-0.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m282.5 480.2q0.4 0 0.8-0.1v-22.8h-0.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m301.3 473.3q0.4-0.4 0.8-0.7v-15.3h-0.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m305.1 469.2q0.4-0.7 0.8-1.5v-10.4h-0.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m297.5 475.8q0.5-0.3 0.9-0.5v-18h-0.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m278.7 480.5q0.4-0.1 0.8-0.1v-23.1h-0.8z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m274.9 480.4q0.5 0.1 0.9 0.1v-23.2h-0.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m267.4 479.6q0.4 0.1 0.8 0.1v-22.4h-0.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m271.2 480.2q0.4 0 0.8 0v-22.9h-0.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m263.6 478.6q0.4 0.2 0.9 0.3v-21.6h-0.9z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m248.6 468.5q0.3 0.7 0.8 1.3v-12.5h-0.8z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m252.3 472.9q0.4 0.4 0.9 0.7v-16.3h-0.9z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m259.9 477.3q0.4 0.2 0.8 0.4v-20.4h-0.8z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m256.1 475.5q0.4 0.3 0.8 0.5v-18.7h-0.8z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m307 454.5c0 9.6-13.4 17.4-30 17.4-16.5 0-29.9-7.8-29.9-17.4 0-9.7 13.4-17.5 29.9-17.5 16.6 0 30 7.8 30 17.5z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m277 471.5c-16.2 0-29.3-7.5-29.9-16.9 0 0.2 0 0.4 0 0.6 0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5 0-0.2 0-0.4 0-0.6-0.6 9.4-13.7 16.9-30 16.9z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m299.5 454.5c0 7.2-10.1 13-22.5 13-12.3 0-22.4-5.8-22.4-13 0-7.2 10.1-13.1 22.4-13.1 12.4 0 22.5 5.9 22.5 13.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m277.8 442.1c12 0 21.7 5.4 22.4 12.3q0-0.3 0-0.7c0-7.2-10-13-22.4-13-12.4 0-22.4 5.8-22.4 13q0 0.4 0 0.7c0.7-6.9 10.4-12.3 22.4-12.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m277 442.8c12 0 21.8 5.5 22.4 12.4q0.1-0.4 0.1-0.7c0-7.2-10.1-13.1-22.5-13.1-12.3 0-22.4 5.9-22.4 13.1q0 0.3 0.1 0.7c0.6-6.9 10.4-12.4 22.3-12.4z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m263.1 463.4c6.7 2.3 11.3 6.9 10.1 10.2-1.1 3.4-7.5 4.2-14.2 1.9-6.8-2.3-11.3-6.9-10.2-10.2 1.2-3.3 7.6-4.2 14.3-1.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m292.8 437.6c6.7 2.3 11.3 6.9 10.1 10.2-1.1 3.4-7.5 4.2-14.2 1.9-6.8-2.3-11.3-6.8-10.2-10.2 1.2-3.3 7.6-4.2 14.3-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "Y",
    d: "m278.8 450.4q-0.9 0.1-1.7 0.4-0.8 0.2-1.7 0.4-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.1 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.5 0.4 0.7 0 1.5-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.2-2.4-1.5q-1.9 1-4 1.7-2.2 0.8-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.3 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.7-1.5 0.5-2.7 0.7-1.3 0.3-2.3 0.4-1 0-1.9-0.2-0.9-0.2-1.6-0.6-1.1-0.6-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.6l-2-1.1 2-1.2 2.1 1.2q0.9-0.5 1.8-0.8 1-0.4 1.9-0.7 0.9-0.3 1.8-0.5 0.8-0.2 1.6-0.4zm-6.8 3.2q0.3 0.2 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.7-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.2-0.2-0.4z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "Z",
    d: "m278.8 449.6q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.6l1.8 1.1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.3 1.5-0.5 2.8-0.9 1.4-0.3 2.6-0.5 1.2-0.1 2.3 0.1 1 0.2 2 0.8 1.2 0.6 1.5 1.4 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.7-1.9 1.5l2.4 1.4-2 1.1-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.1l-1.3-3.2q1-0.2 2.1-0.4 0.9-0.3 2.1-0.6 1.1-0.4 2.1-0.8l-1.8-1.1q-0.9 0.4-1.9 0.7-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.3-1 0.1-1.9-0.1-0.9-0.2-1.6-0.7-1.1-0.6-1.5-1.3-0.4-0.8-0.2-1.6 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.5l-2-1.2 2-1.2 2.1 1.2q0.9-0.4 1.8-0.8 1-0.3 1.9-0.6 0.9-0.3 1.8-0.5 0.8-0.3 1.6-0.5zm-6.8 3.2q0.3 0.2 0.7 0.2 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.6-0.3 0.9zm9.6 1.7q-0.2-0.2-0.8-0.2-0.5 0.1-1.1 0.3l1.4 0.9q0.6-0.4 0.7-0.7 0.1-0.2-0.2-0.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a0",
    d: "m278.8 449.6q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.6l1.8 1.1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.3 1.5-0.5 2.8-0.9 1.4-0.3 2.6-0.5 1.2-0.1 2.3 0.1 1 0.2 2 0.8 1.2 0.6 1.5 1.4 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.7-1.9 1.5l2.4 1.4-2 1.1-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.1l-1.3-3.2q1-0.2 2.1-0.4 0.9-0.3 2.1-0.6 1.1-0.4 2.1-0.8l-1.8-1.1q-0.9 0.4-1.9 0.7-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.3-1 0.1-1.9-0.1-0.9-0.2-1.6-0.7-1.1-0.6-1.5-1.3-0.4-0.8-0.2-1.6 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.5l-2-1.2 2-1.2 2.1 1.2q0.9-0.4 1.8-0.8 1-0.3 1.9-0.6 0.9-0.3 1.8-0.5 0.8-0.3 1.6-0.5zm-6.8 3.2q0.3 0.2 0.7 0.2 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.6-0.3 0.9zm9.6 1.7q-0.2-0.2-0.8-0.2-0.5 0.1-1.1 0.3l1.4 0.9q0.6-0.4 0.7-0.7 0.1-0.2-0.2-0.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m254.2 444.7c0 5.1 10 9.3 22.4 9.3 12.3 0 22.3-4.2 22.3-9.3 0-5.2-10-9.3-22.3-9.3-12.4 0-22.4 4.1-22.4 9.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m307 420h-59.9v8.4q0 0.1 0 0.3c0 9.6 13.4 17.4 29.9 17.4 16.6 0 30-7.8 30-17.4q0-0.2 0-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m247.1 427.3v0.2q0-0.1 0-0.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m277 444.3c-16.5 0-29.9-7.9-29.9-17.5v1.6q0 0.1 0 0.3c0 9.6 13.4 17.4 29.9 17.4 16.6 0 30-7.8 30-17.4q0-0.2 0-0.3v-1.6c0 9.6-13.4 17.5-30 17.5z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "a5",
    d: "m307 427.5v-0.2q0 0.1 0 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m286.2 445.3q0.5-0.1 0.9-0.2v-22.2h-0.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m290 444.4q0.4-0.1 0.8-0.2v-21.3h-0.8z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m293.8 443.2q0.4-0.2 0.8-0.4v-19.9h-0.8z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m282.5 445.8q0.4 0 0.8-0.1v-22.8h-0.8z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m301.3 438.9q0.4-0.3 0.8-0.7v-15.3h-0.8z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m305.1 434.8q0.4-0.7 0.8-1.4v-10.5h-0.8z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m297.5 441.4q0.5-0.2 0.9-0.5v-18h-0.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m278.7 446.1q0.4 0 0.8 0v-23.2h-0.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m274.9 446.1q0.5 0 0.9 0v-23.2h-0.9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m267.4 445.2q0.4 0.1 0.8 0.2v-22.5h-0.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m271.2 445.8q0.4 0 0.8 0.1v-23h-0.8z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m263.6 444.3q0.4 0.1 0.9 0.2v-21.6h-0.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m248.6 434.1q0.3 0.7 0.8 1.3v-12.5h-0.8z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m252.3 438.5q0.4 0.4 0.9 0.7v-16.3h-0.9z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m259.9 443q0.4 0.1 0.8 0.3v-20.4h-0.8z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m256.1 441.1q0.4 0.3 0.8 0.5v-18.7h-0.8z"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m307 420.1c0 9.6-13.4 17.4-30 17.4-16.5 0-29.9-7.8-29.9-17.4 0-9.7 13.4-17.5 29.9-17.5 16.6 0 30 7.8 30 17.5z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m277 437.1c-16.2 0-29.3-7.5-29.9-16.9 0 0.2 0 0.4 0 0.6 0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5 0-0.2 0-0.4 0-0.6-0.6 9.4-13.7 16.9-30 16.9z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m299.5 420.1c0 7.2-10.1 13-22.5 13-12.3 0-22.4-5.8-22.4-13 0-7.2 10.1-13.1 22.4-13.1 12.4 0 22.5 5.9 22.5 13.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m277.8 407.7c12 0 21.7 5.5 22.4 12.3q0-0.3 0-0.7c0-7.2-10-13-22.4-13-12.4 0-22.4 5.8-22.4 13q0 0.4 0 0.7c0.7-6.8 10.4-12.3 22.4-12.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m277 408.4c12 0 21.8 5.5 22.4 12.4q0.1-0.4 0.1-0.7c0-7.2-10.1-13.1-22.5-13.1-12.3 0-22.4 5.9-22.4 13.1q0 0.3 0.1 0.7c0.6-6.9 10.4-12.4 22.3-12.4z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m263.1 429c6.7 2.3 11.3 6.9 10.1 10.2-1.1 3.4-7.5 4.2-14.2 1.9-6.8-2.3-11.3-6.8-10.2-10.2 1.2-3.3 7.6-4.2 14.3-1.9z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m292.8 403.3c6.7 2.3 11.3 6.8 10.1 10.2-1.1 3.3-7.5 4.1-14.2 1.8-6.8-2.2-11.3-6.8-10.2-10.1 1.2-3.4 7.6-4.2 14.3-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ad",
    d: "m278.8 416q-0.9 0.1-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.6l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.5 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.1 2.3 0.1 1 0.2 2 0.7 1.2 0.7 1.5 1.5 0.4 0.8 0 1.6-0.3 0.8-1.1 1.5-0.8 0.8-1.9 1.5l2.4 1.4-2 1.2-2.4-1.4q-1.9 0.9-4 1.6-2.2 0.8-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.3 2.1-0.8l-1.8-1q-0.9 0.4-1.9 0.7-1.5 0.5-2.7 0.8-1.3 0.2-2.3 0.3-1 0-1.9-0.2-0.9-0.1-1.6-0.6-1.1-0.6-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.6l-2-1.1 2-1.2 2.1 1.2q0.9-0.4 1.8-0.8 1-0.4 1.9-0.7 0.9-0.2 1.8-0.5 0.8-0.2 1.6-0.4zm-6.8 3.2q0.3 0.2 0.7 0.2 0.5-0.1 1.2-0.3l-1.6-0.9q-0.9 0.7-0.3 1zm9.6 1.6q-0.2-0.1-0.8-0.1-0.5 0.1-1.1 0.3l1.4 0.8q0.6-0.4 0.7-0.6 0.1-0.2-0.2-0.4z"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ae",
    d: "m278.8 415.2q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-1 1.4-0.3 2.6-0.4 1.2-0.2 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.4 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.1-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.4 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.6-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.3-1 0.1-1.9-0.1-0.9-0.2-1.6-0.6-1.1-0.7-1.5-1.4-0.4-0.8-0.2-1.5 0.2-0.8 0.9-1.7 0.7-0.8 1.7-1.5l-2-1.2 2-1.1 2.1 1.1q0.9-0.4 1.8-0.8 1-0.3 1.9-0.6 0.9-0.3 1.8-0.5 0.8-0.3 1.6-0.4zm-6.8 3.2q0.3 0.1 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.6-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.3-0.2-0.4z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "af",
    d: "m278.8 415.2q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-1 1.4-0.3 2.6-0.4 1.2-0.2 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.4 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.1-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.4 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.6-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.3-1 0.1-1.9-0.1-0.9-0.2-1.6-0.6-1.1-0.7-1.5-1.4-0.4-0.8-0.2-1.5 0.2-0.8 0.9-1.7 0.7-0.8 1.7-1.5l-2-1.2 2-1.1 2.1 1.1q0.9-0.4 1.8-0.8 1-0.3 1.9-0.6 0.9-0.3 1.8-0.5 0.8-0.3 1.6-0.4zm-6.8 3.2q0.3 0.1 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.6-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.3-0.2-0.4z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m333.5 436.7v60.3q23.4-13.5 23.3-32.7v-60.3q0.1 19.2-23.3 32.7z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m297.3 415.8l0.2 0.1v60.2l36 20.9v-60.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "m333.5 436.1l-34.9-20.2c-0.4 0.3-0.7 0.5-1.1 0.7l36 20.8q23.4-13.5 23.3-32.7 0-0.2 0-0.5-0.4 18.6-23.3 31.9z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m276.4 357.5c-44.3 0-80.1 20.6-80 46.2l50.8 0.1c0-4.3 2.8-8.7 8.5-12 11.5-6.6 30.1-6.6 41.6 0.1 11.6 6.6 11.6 17.4 0.2 24l36 20.8q23.4-13.5 23.3-32.7c-0.1-25.6-36.1-46.4-80.4-46.5z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "m306 404c0.3-4.6-2.6-9.2-8.7-12.7-11.5-6.7-30.1-6.7-41.6-0.1-5.7 3.3-8.5 7.6-8.5 12l-50.7-0.1q-0.1 0.7-0.1 1.3l50.8 0.1c0-4.3 2.8-8.6 8.5-12 11.5-6.6 30.1-6.5 41.6 0.1 5.5 3.2 8.4 7.3 8.7 11.4z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "m254.2 409.8c0 5.2 10 9.3 22.4 9.3 12.3 0 22.3-4.1 22.3-9.3 0-5.1-10-9.3-22.3-9.3-12.4 0-22.4 4.2-22.4 9.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m297.8 454.9q-0.2 0.1-0.3 0.2c-5.8 3.3-13.3 5-20.9 4.9v21c7.6 0.1 15.1-1.6 20.9-4.9q0.1-0.1 0.3-0.2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m276.9 488.5l-0.2-28.8q0 0 0.1 0l-0.2-0.2 0.3 50.9q33.2 0.1 56.6-13.4v-22q-23.4 13.5-56.6 13.5z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "m297.9 454.5q-0.2 0.1-0.4 0.3c-5.7 3.3-13.3 4.9-20.8 4.9l0.2 29.5c22.1 0 41-5.2 56.6-14.2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "m276.9 488.1l-0.3-28.3v0.1l0.3 29.3q33.2 0.1 56.6-13.4l-1-0.6q-23.1 12.9-55.6 12.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "m276.7 442.6c-7.5 0-15.1-1.7-20.8-5-5.9-3.4-8.8-7.8-8.7-12.2v38.6c0 4.3 2.9 8.7 8.7 12 5.7 3.3 13.3 5 20.8 5z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m196.4 425.2v38.8c0.1 25.6 36.2 46.4 80.5 46.4v-38.8c-44.3-0.1-80.4-20.9-80.5-46.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "m333.5 498.9v11.8q23.4-13.5 23.3-32.7v-11.8q0.1 19.2-23.3 32.7z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "m276.9 512.5l-0.2-28.8q0 0 0.1 0l-0.2-0.2 0.3 40.7q33.2 0 56.6-13.5v-11.7q-23.4 13.5-56.6 13.5z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "m196.4 466v11.7c0.1 25.6 36.2 46.4 80.5 46.5v-11.7c-44.3-0.1-80.4-20.9-80.5-46.5z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "m255.9 437.6c-5.9-3.4-8.8-7.9-8.7-12.4h-50.8c0.1 25.5 36.2 46.3 80.5 46.4l-0.2-29c-7.5 0-15.1-1.7-20.8-5z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m276.6 442.4h-0.4l0.3 28.6c-39.6 0-72.6-16.7-79.2-38.5 5.7 22.5 39.2 39.8 79.6 39.9z"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m243.6 452.5c7.6-0.1 13.8 21.7 13.9 48.4 0 26.8-6.2 48.6-13.8 48.6-7.6 0-13.8-21.7-13.8-48.5-0.1-26.8 6.1-48.5 13.7-48.5z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m285.4 353.7c7.7 0 13.9 21.7 13.9 48.5 0 26.7-6.1 48.5-13.7 48.5-7.6 0-13.8-21.7-13.9-48.5 0-26.8 6.1-48.5 13.7-48.5z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m307 248.2h-59.9v144.2q0 0.1 0 0.2c0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5q0-0.1 0-0.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "aA",
    d: "m307 384h-59.9v8.4q0 0.2 0 0.3c0 9.6 13.4 17.4 29.9 17.4 16.6 0 30-7.8 30-17.4q0-0.1 0-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m247.1 391.3v0.3q0-0.2 0-0.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "aC",
    d: "m277 408.3c-16.5 0-29.9-7.8-29.9-17.5v1.6q0 0.2 0 0.3c0 9.6 13.4 17.4 29.9 17.4 16.6 0 30-7.8 30-17.4q0-0.1 0-0.3v-1.6c0 9.7-13.4 17.5-30 17.5z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "aD",
    d: "m307 391.6v-0.3q0 0.1 0 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m286.2 409.3q0.5-0.1 0.9-0.2v-22.1h-0.9z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m290 408.4q0.4-0.1 0.8-0.2v-21.2h-0.8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m293.8 407.2q0.4-0.2 0.8-0.4v-19.8h-0.8z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m282.5 409.8q0.4 0 0.8 0v-22.8h-0.8z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m301.3 402.9q0.4-0.3 0.8-0.7v-15.2h-0.8z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m305.1 398.9q0.4-0.8 0.8-1.5v-10.4h-0.8z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m297.5 405.4q0.5-0.2 0.9-0.4v-18h-0.9z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m278.7 410.1q0.4 0 0.8 0v-23.1h-0.8z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m274.9 410.1q0.5 0 0.9 0v-23.1h-0.9z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m267.4 409.2q0.4 0.1 0.8 0.2v-22.4h-0.8z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m271.2 409.8q0.4 0 0.8 0.1v-22.9h-0.8z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m263.6 408.3q0.4 0.1 0.9 0.2v-21.5h-0.9z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m248.6 398.1q0.3 0.7 0.8 1.4v-12.5h-0.8z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m252.3 402.6q0.4 0.3 0.9 0.6v-16.2h-0.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m259.9 407q0.4 0.2 0.8 0.3v-20.3h-0.8z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m256.1 405.2q0.4 0.2 0.8 0.4v-18.6h-0.8z"
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "aE",
    d: "m307 384.1c0 9.6-13.4 17.5-30 17.5-16.5 0-29.9-7.9-29.9-17.5 0-9.6 13.4-17.5 29.9-17.5 16.6 0 30 7.9 30 17.5z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "aF",
    d: "m277 401.1c-16.2 0-29.3-7.5-29.9-16.9 0 0.2 0 0.4 0 0.6 0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5 0-0.2 0-0.4 0-0.6-0.6 9.4-13.7 16.9-30 16.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "aG",
    d: "m299.5 384.1c0 7.2-10.1 13.1-22.5 13.1-12.3 0-22.4-5.9-22.4-13.1 0-7.2 10.1-13.1 22.4-13.1 12.4 0 22.5 5.9 22.5 13.1z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "aH",
    d: "m277.8 371.7c12 0 21.7 5.5 22.4 12.4q0-0.4 0-0.7c0-7.3-10-13.1-22.4-13.1-12.4 0-22.4 5.8-22.4 13.1q0 0.3 0 0.7c0.7-6.9 10.4-12.4 22.4-12.4z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "aI",
    d: "m277 372.4c12 0 21.8 5.5 22.4 12.4q0.1-0.3 0.1-0.7c0-7.2-10.1-13.1-22.5-13.1-12.3 0-22.4 5.9-22.4 13.1q0 0.4 0.1 0.7c0.6-6.9 10.4-12.4 22.3-12.4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "aJ",
    d: "m263.1 393.1c6.7 2.3 11.3 6.8 10.1 10.2-1.1 3.3-7.5 4.1-14.2 1.8-6.8-2.2-11.3-6.8-10.2-10.2 1.2-3.3 7.6-4.1 14.3-1.8z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "aK",
    d: "m292.8 367.3c6.7 2.3 11.3 6.8 10.1 10.2-1.1 3.3-7.5 4.2-14.2 1.9-6.8-2.3-11.3-6.9-10.2-10.2 1.2-3.4 7.6-4.2 14.3-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aL",
    d: "m278.8 380q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.6l1.8 1.1q0.3-0.1 0.6-0.3 0.3-0.1 0.7-0.2 1.5-0.5 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.1 2.3 0.1 1 0.2 2 0.7 1.2 0.7 1.5 1.5 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.7-1.9 1.4l2.4 1.4-2 1.2-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.1l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.5 1.1-0.4 2.1-0.9l-1.8-1q-0.9 0.4-1.9 0.7-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.3-1 0.1-1.9-0.1-0.9-0.2-1.6-0.7-1.1-0.6-1.5-1.3-0.4-0.8-0.2-1.6 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.5l-2-1.2 2-1.2 2.1 1.2q0.9-0.4 1.8-0.8 1-0.3 1.9-0.6 0.9-0.3 1.8-0.6 0.8-0.2 1.6-0.4zm-6.8 3.2q0.3 0.2 0.7 0.2 0.5-0.1 1.2-0.3l-1.6-0.8q-0.9 0.6-0.3 0.9zm9.6 1.6q-0.2-0.1-0.8-0.1-0.5 0.1-1.1 0.3l1.4 0.8q0.6-0.3 0.7-0.6 0.1-0.2-0.2-0.4z"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aM",
    d: "m278.8 379.3q-0.9 0.1-1.7 0.4-0.8 0.1-1.7 0.4-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.1 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.5 0.4 0.7 0 1.5-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.2-2.4-1.5q-1.9 1-4 1.7-2.2 0.8-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.3 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.7-1.5 0.5-2.7 0.7-1.3 0.3-2.3 0.4-1 0-1.9-0.2-0.9-0.2-1.6-0.6-1.1-0.6-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.6l-2-1.2 2-1.1 2.1 1.2q0.9-0.5 1.8-0.8 1-0.4 1.9-0.7 0.9-0.3 1.8-0.5 0.8-0.2 1.6-0.4zm-6.8 3.2q0.3 0.2 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.7-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.3-0.2-0.4z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aN",
    d: "m278.8 379.3q-0.9 0.1-1.7 0.4-0.8 0.1-1.7 0.4-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.1 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.5 0.4 0.7 0 1.5-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.2-2.4-1.5q-1.9 1-4 1.7-2.2 0.8-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.3 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.7-1.5 0.5-2.7 0.7-1.3 0.3-2.3 0.4-1 0-1.9-0.2-0.9-0.2-1.6-0.6-1.1-0.6-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.6l-2-1.2 2-1.1 2.1 1.2q0.9-0.5 1.8-0.8 1-0.4 1.9-0.7 0.9-0.3 1.8-0.5 0.8-0.2 1.6-0.4zm-6.8 3.2q0.3 0.2 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.7-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.3-0.2-0.4z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m307 335.8h-59.9v8.4q0 0.1 0 0.3c0 9.6 13.4 17.4 29.9 17.4 16.6 0 30-7.8 30-17.4q0-0.2 0-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m247.1 343.1v0.2q0-0.1 0-0.2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "aQ",
    d: "m277 360.1c-16.5 0-29.9-7.9-29.9-17.5v1.6q0 0.1 0 0.3c0 9.6 13.4 17.4 29.9 17.4 16.6 0 30-7.8 30-17.4q0-0.2 0-0.3v-1.6c0 9.6-13.4 17.5-30 17.5z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "aR",
    d: "m307 343.3v-0.2q0 0.1 0 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m286.2 361.1q0.5-0.1 0.9-0.2v-22.2h-0.9z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m290 360.2q0.4-0.1 0.8-0.2v-21.3h-0.8z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m293.8 359q0.4-0.2 0.8-0.4v-19.9h-0.8z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m282.5 361.6q0.4 0 0.8-0.1v-22.8h-0.8z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m301.3 354.7q0.4-0.3 0.8-0.7v-15.3h-0.8z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m305.1 350.6q0.4-0.7 0.8-1.4v-10.5h-0.8z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m297.5 357.2q0.5-0.2 0.9-0.5v-18h-0.9z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m278.7 361.9q0.4 0 0.8 0v-23.2h-0.8z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m274.9 361.9q0.5 0 0.9 0v-23.2h-0.9z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m267.4 361q0.4 0.1 0.8 0.2v-22.5h-0.8z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m271.2 361.6q0.4 0 0.8 0.1v-23h-0.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m263.6 360.1q0.4 0.1 0.9 0.2v-21.6h-0.9z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m248.6 349.9q0.3 0.7 0.8 1.3v-12.5h-0.8z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m252.3 354.3q0.4 0.4 0.9 0.7v-16.3h-0.9z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m259.9 358.8q0.4 0.1 0.8 0.3v-20.4h-0.8z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m256.1 356.9q0.4 0.3 0.8 0.5v-18.7h-0.8z"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "aS",
    d: "m307 335.9c0 9.6-13.4 17.4-30 17.4-16.5 0-29.9-7.8-29.9-17.4 0-9.7 13.4-17.5 29.9-17.5 16.6 0 30 7.8 30 17.5z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "aT",
    d: "m277 352.9c-16.2 0-29.3-7.5-29.9-16.9 0 0.2 0 0.4 0 0.6 0 9.7 13.4 17.5 29.9 17.5 16.6 0 30-7.8 30-17.5 0-0.2 0-0.4 0-0.6-0.6 9.4-13.7 16.9-30 16.9z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "aU",
    d: "m299.5 335.9c0 7.2-10.1 13-22.5 13-12.3 0-22.4-5.8-22.4-13 0-7.2 10.1-13.1 22.4-13.1 12.4 0 22.5 5.9 22.5 13.1z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "aV",
    d: "m277.8 323.5c12 0 21.7 5.5 22.4 12.3q0-0.3 0-0.7c0-7.2-10-13-22.4-13-12.4 0-22.4 5.8-22.4 13q0 0.4 0 0.7c0.7-6.8 10.4-12.3 22.4-12.3z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "aW",
    d: "m277 324.2c12 0 21.8 5.5 22.4 12.4q0.1-0.4 0.1-0.7c0-7.2-10.1-13.1-22.5-13.1-12.3 0-22.4 5.9-22.4 13.1q0 0.3 0.1 0.7c0.6-6.9 10.4-12.4 22.3-12.4z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "aX",
    d: "m263.1 344.8c6.7 2.3 11.3 6.9 10.1 10.2-1.1 3.4-7.5 4.2-14.2 1.9-6.8-2.3-11.3-6.8-10.2-10.2 1.2-3.3 7.6-4.1 14.3-1.9z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "aY",
    d: "m292.8 319.1c6.7 2.3 11.3 6.8 10.1 10.2-1.1 3.3-7.5 4.1-14.2 1.9-6.8-2.3-11.3-6.9-10.2-10.2 1.2-3.4 7.6-4.2 14.3-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aZ",
    d: "m278.8 331.8q-0.9 0.1-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.6l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.5 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.1 2.3 0.1 1 0.2 2 0.7 1.2 0.7 1.5 1.5 0.4 0.8 0 1.6-0.3 0.8-1.1 1.5-0.8 0.8-1.9 1.5l2.4 1.4-2 1.2-2.4-1.4q-1.9 0.9-4 1.6-2.2 0.8-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.3 2.1-0.8l-1.8-1q-0.9 0.4-1.9 0.7-1.5 0.5-2.7 0.8-1.3 0.2-2.3 0.3-1 0-1.9-0.1-0.9-0.2-1.6-0.7-1.1-0.6-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.6 0.7-0.8 1.7-1.6l-2-1.1 2-1.2 2.1 1.2q0.9-0.4 1.8-0.8 1-0.4 1.9-0.7 0.9-0.2 1.8-0.5 0.8-0.2 1.6-0.4zm-6.8 3.2q0.3 0.2 0.7 0.2 0.5-0.1 1.2-0.3l-1.6-0.9q-0.9 0.7-0.3 1zm9.6 1.6q-0.2-0.1-0.8-0.1-0.5 0.1-1.1 0.3l1.4 0.8q0.6-0.3 0.7-0.6 0.1-0.2-0.2-0.4z"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b0",
    d: "m278.8 331q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.2 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.4 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.1-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.4 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.6-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.4-1 0-1.9-0.2-0.9-0.2-1.6-0.6-1.1-0.7-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.7 0.7-0.8 1.7-1.5l-2-1.2 2-1.1 2.1 1.1q0.9-0.4 1.8-0.7 1-0.4 1.9-0.7 0.9-0.3 1.8-0.5 0.8-0.3 1.6-0.4zm-6.8 3.2q0.3 0.1 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.6-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.3-0.2-0.4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b1",
    d: "m278.8 331q-0.9 0.2-1.7 0.4-0.8 0.2-1.7 0.5-0.9 0.3-1.7 0.7l1.8 1q0.3-0.1 0.6-0.2 0.3-0.1 0.7-0.2 1.5-0.6 2.8-0.9 1.4-0.4 2.6-0.5 1.2-0.2 2.3 0 1 0.2 2 0.8 1.2 0.7 1.5 1.4 0.4 0.8 0 1.6-0.3 0.8-1.1 1.6-0.8 0.8-1.9 1.5l2.4 1.4-2 1.1-2.4-1.4q-1.9 0.9-4 1.7-2.2 0.7-4.2 1.2l-1.3-3.2q1-0.2 2.1-0.5 0.9-0.2 2.1-0.6 1.1-0.4 2.1-0.8l-1.8-1q-0.9 0.3-1.9 0.6-1.5 0.5-2.7 0.8-1.3 0.3-2.3 0.4-1 0-1.9-0.2-0.9-0.2-1.6-0.6-1.1-0.7-1.5-1.4-0.4-0.7-0.2-1.5 0.2-0.8 0.9-1.7 0.7-0.8 1.7-1.5l-2-1.2 2-1.1 2.1 1.1q0.9-0.4 1.8-0.7 1-0.4 1.9-0.7 0.9-0.3 1.8-0.5 0.8-0.3 1.6-0.4zm-6.8 3.2q0.3 0.1 0.7 0.1 0.5 0 1.2-0.2l-1.6-0.9q-0.9 0.6-0.3 1zm9.6 1.6q-0.2-0.2-0.8-0.1-0.5 0-1.1 0.2l1.4 0.9q0.6-0.4 0.7-0.6 0.1-0.3-0.2-0.4z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "b2",
    d: "m254.2 379.1c0 5.1 10 9.3 22.4 9.3 12.3 0 22.3-4.2 22.3-9.3 0-5.2-10-9.4-22.3-9.4-12.4 0-22.4 4.2-22.4 9.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "b3",
    d: "m543.1 100.2c-11.8-6.9-21.4-1.4-21.4 12.2v197.6c0 13.6 9.6 30.2 21.4 37l66.8 37.3c11.8 6.9 26.2 0.6 26.2-13v-197.6c0-13.6-14.4-29.4-26.2-36.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "b4",
    d: "m542 100.6c-11.9-6.8-21.5-1.3-21.5 12.3v196.9c0 13.6 9.6 30.1 21.5 37l66.8 37.3c11.8 6.9 25.8 0.7 25.8-12.9v-196.9c0-13.6-14-29.5-25.8-36.3z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "b5",
    d: "m540.8 101.1c-11.8-6.8-21.4-1.3-21.4 12.3v196.1c0 13.6 9.6 30.2 21.4 37l66.9 37.4c11.8 6.8 25.3 0.7 25.3-12.9v-196.1c0-13.6-13.5-29.6-25.3-36.4z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "b6",
    d: "m539.7 101.6c-11.9-6.8-21.5-1.4-21.5 12.3v195.4c0 13.6 9.6 30.2 21.5 37l66.9 37.4c11.8 6.8 24.9 0.8 24.9-12.8v-195.4c0-13.6-13.1-29.7-24.9-36.5z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "b7",
    d: "m538.6 102.1c-11.9-6.8-21.5-1.4-21.5 12.2v194.7c0 13.6 9.6 30.2 21.5 37l66.9 37.5c11.8 6.8 24.5 0.8 24.5-12.8v-194.6c0-13.6-12.7-29.7-24.5-36.6z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "b8",
    d: "m537.4 102.6c-11.8-6.9-21.5-1.4-21.5 12.2v194c0 13.6 9.7 30.2 21.5 37l67 37.4c11.8 6.9 24 1 24-12.6v-194c0-13.6-12.2-29.7-24-36.6z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "b9",
    d: "m536.3 103.1c-11.9-6.9-21.5-1.4-21.5 12.2v193.2c0 13.6 9.6 30.2 21.5 37.1l66.9 37.4c11.9 6.9 23.7 1 23.7-12.6v-193.2c0-13.6-11.8-29.8-23.7-36.7z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "m535.1 103.6c-11.8-6.9-21.4-1.4-21.4 12.2v192.5c0 13.6 9.6 30.2 21.4 37l67 37.5c11.9 6.8 23.3 1.1 23.3-12.5v-192.5c0-13.6-11.4-29.9-23.3-36.8z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "m534 104.1c-11.9-6.9-21.5-1.4-21.5 12.2v191.7c0 13.6 9.6 30.2 21.5 37.1l67 37.5c11.9 6.8 22.8 1.1 22.8-12.5v-191.7c0-13.6-10.9-30-22.8-36.8z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "m532.9 104.5c-11.9-6.8-21.5-1.3-21.5 12.3v191c0 13.6 9.6 30.2 21.5 37l67 37.5c11.9 6.9 22.4 1.3 22.4-12.3v-191c0-13.6-10.5-30.1-22.4-36.9z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "m531.7 105c-11.8-6.8-21.5-1.3-21.5 12.3v190.2c0 13.6 9.7 30.2 21.5 37.1l67.1 37.5c11.9 6.9 21.9 1.3 21.9-12.3v-190.2c0-13.6-10-30.2-21.9-37z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "m530.6 105.5c-11.9-6.8-21.5-1.4-21.5 12.3v189.4c0 13.7 9.6 30.3 21.5 37.1l67.1 37.6c11.9 6.9 21.5 1.4 21.5-12.3v-189.4c0-13.7-9.6-30.2-21.5-37.1z"
  }))), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "m530 103.7c-11.9-6.9-21.6-1.4-21.6 12.3v201.7c0 13.7 9.7 30.3 21.6 37.2l67.6 37.9c11.9 6.9 21.6 1.4 21.6-12.3v-201.7c0-13.7-9.7-30.3-21.6-37.2z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "m597.6 141.6l-67.6-37.9c-11.9-6.9-21.6-1.4-21.6 12.3v2.1c0-13.7 9.7-19.2 21.6-12.3l67.6 37.9c11.9 6.9 21.6 23.5 21.6 37.2v-2.1c0-13.7-9.7-30.3-21.6-37.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "m563 162.2v-13.5c13.4 7.7 25.1 21.7 32.6 38.7l-9.8 1.9c-4.9-11.2-13.3-21.6-22.8-27.1z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "m563 225.4c15.2 8.8 27.5 1.8 27.5-15.7 0-6.5-1.7-13.6-4.7-20.4l9.8-1.9c1.9 4.2 3.2 8.1 4.4 12.3 7.4 27.8-3.1 47.6-23.6 44.3-20.4-3.2-43-28.4-50.4-56.1l11.1 1.8c3.8 14.3 14 28.8 25.9 35.7z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "m545.1 143.3l5.4 15.2c-8.9 0-15.1 7.1-15.1 19.4 0 3.8 0.6 7.8 1.7 11.8l-11.1-1.8c-6.8-25.6 1.3-44.5 19.1-44.6z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "m563 162.2c-4.5-2.6-8.8-3.8-12.5-3.7l-5.4-15.2c6-0.1 11.2 1.5 17.9 5.4v13.5q0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "m563 271.4h-0.1v-13.8c15.4 8.9 28.8 26.2 35.6 46l-10.8-0.2c-4.5-13.1-13.9-25.7-24.7-32z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "m563 334.6c15.2 8.7 27.5 1.7 27.5-15.7 0-5-1-10.3-2.8-15.5l10.8 0.2c3.9 11.5 5 21.3 3.3 30.4-4.2 22.2-25 26.3-46.4 9.1l2.3-12.2q2.6 2.1 5.3 3.7z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "m557.7 330.9l-2.3 12.2c-5-4-9.1-8.1-13.4-13.8l6.4-8c2.8 3.7 5.9 6.9 9.3 9.6z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "m548.4 321.3l-6.4 8c-8.7-11.2-14.6-23.7-17.3-36.7l11.7 3.2c1.8 8.8 6.1 18 12 25.5z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "m562.9 257.6v13.8c-15.2-8.8-27.5-1.8-27.5 15.7 0 2.8 0.4 5.7 1 8.7l-11.7-3.2c-1-4.8-1.3-8.1-1.3-12.5 0-25 17.7-35.1 39.5-22.5z"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bq",
    d: "m563 171.5c10.7 6.2 19.5 21.2 19.5 33.6 0 12.3-8.8 17.3-19.5 11.1-10.8-6.2-19.5-21.3-19.5-33.6 0-12.4 8.7-17.3 19.5-11.1zm1.2 11.8c1.9 1 3.7 1.8 5.4 2.4-1.3-4.7-3.2-8.5-5.4-10.5zm0 2.8v7l7.3 4.2c-0.1-2.9-0.5-5.8-1.1-8.5-1.9-0.6-4-1.5-6.2-2.7zm0 9.8v7c2.2 1.4 4.3 2.9 6.2 4.5 0.6-2 1-4.5 1.1-7.3zm0 9.8v8.1c2.1 0.5 4.1-1.1 5.4-4.1-1.7-1.5-3.5-2.8-5.4-4zm-2.5-1.4c-1.9-1-3.7-1.8-5.4-2.4 1.3 4.7 3.2 8.5 5.4 10.5zm0-2.8v-7l-7.2-4.2c0 2.9 0.4 5.8 1 8.5 1.9 0.6 4 1.6 6.2 2.7zm0-9.8v-7c-2.2-1.3-4.3-2.9-6.2-4.5-0.6 2.1-1 4.5-1 7.3zm0-9.8v-8.1c-2.2-0.5-4.2 1.1-5.5 4.2 1.7 1.4 3.6 2.7 5.5 3.9zm-5.3-9.9c-2-0.2-3.9 0.1-5.4 0.9q1.3 1.5 2.8 3 1.1-2.6 2.6-3.9zm15.5 14.3q1.5 0.3 2.8 0.3c-1.5-2.6-3.3-5-5.3-7.1 1 2 1.8 4.3 2.5 6.8zm0.8 3.1c0.6 3 1 6.2 1.1 9.3l6.1 3.5c-0.3-4-1.5-8.4-3.5-12.4q-1.7 0-3.7-0.4zm1.1 12.1c-0.1 3.1-0.5 5.8-1.1 8.1q2 1.9 3.7 3.9c2-1.8 3.2-4.7 3.5-8.5zm-1.9 10.3q-1.1 2.5-2.6 3.9c2 0.2 3.9-0.2 5.4-1q-1.3-1.5-2.8-2.9zm-18.1-10.5q-1.5-0.3-2.8-0.3c1.5 2.6 3.3 5 5.3 7.1-1-2-1.8-4.3-2.5-6.8zm-0.8-3.1c-0.6-3-1-6.1-1.1-9.3l-6.1-3.5c0.3 4.1 1.5 8.4 3.5 12.5q1.7-0.1 3.7 0.3zm-1.1-12.1c0.1-3.1 0.5-5.8 1.1-8q-2-1.9-3.7-4c-2 1.9-3.2 4.7-3.5 8.5z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bq",
    d: "m563 280.6c10.7 6.2 19.4 21.3 19.4 33.6 0 12.4-8.7 17.3-19.4 11.1-10.8-6.2-19.5-21.2-19.5-33.6 0-12.3 8.7-17.3 19.5-11.1zm0 40.3c8.6 4.9 15.6 0.9 15.6-8.9 0-9.9-7-21.9-15.6-26.9-8.6-5-15.6-1-15.6 8.9 0 9.9 7 21.9 15.6 26.9zm0-31.3c6.4 3.7 11.7 12.7 11.7 20.1 0 7.4-5.3 10.4-11.7 6.7-6.5-3.7-11.7-12.8-11.7-20.2 0-7.4 5.2-10.4 11.7-6.6zm0 22.3c4.3 2.5 7.8 0.5 7.8-4.4 0-5-3.5-11-7.8-13.5-4.3-2.5-7.8-0.5-7.8 4.5 0 4.9 3.5 10.9 7.8 13.4zm0-13.4c2.1 1.2 3.9 4.3 3.9 6.7 0 2.5-1.8 3.5-3.9 2.2-2.2-1.2-3.9-4.2-3.9-6.7 0-2.4 1.7-3.4 3.9-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m520.7 501.5l20.5 11.9v-8.4l-20.5-11.8z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m541.2 513.4l20.4-11.9v-8.3l-20.4 11.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m550.1 527.5l20.4 11.8v-16.5l-20.4-11.9z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m570.5 539.3l20.5-11.8v-16.6l-20.5 11.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "m579.8 551.5l20.4 11.8v-24.8l-20.4-11.8z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m600.2 563.3l20.5-11.8v-24.8l-20.5 11.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "m609.1 577.5l20.5 11.8v-33.1l-20.5-11.8z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m629.6 589.3l20.5-11.8v-33.1l-20.5 11.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m639.5 601.5l20.5 11.8v-41.3l-20.5-11.8z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m660 613.3l20.5-11.8v-41.3l-20.5 11.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "m541.2 457.9l-20.5 11.8 20.5 11.9 20.4-11.9z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "m520.7 490.4l20.5 11.8v-20.6l-20.5-11.9z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "m541.2 502.2l20.4-11.8v-20.7l-20.4 11.9z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "bA",
    d: "m541.2 502.2l20.4-11.8v-20.7l-20.4 11.9z"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "bB",
    d: "m561.6 469.7l-20.3 11-20.6-11 19.8 12.3 0.7 20.2 0.9-20.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "bC",
    d: "m570.5 431.2l-20.4 11.9 20.4 11.8 20.5-11.8z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "bD",
    d: "m550.1 508.4l20.4 11.9v-65.4l-20.4-11.8z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "bE",
    d: "m570.5 520.3l20.5-11.9v-65.3l-20.5 11.8z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "bF",
    d: "m570.5 520.3l20.5-11.9v-65.3l-20.5 11.8z"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "bG",
    d: "m591 443.1l-20.4 10.9-20.5-10.9 19.8 12.2 0.6 65 1-65.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "bH",
    d: "m600.1 402.7l-20.5 11.9 20.5 11.8 20.5-11.8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "bI",
    d: "m579.6 524.4l20.5 11.8v-109.8l-20.5-11.8z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "bJ",
    d: "m600.1 536.2l20.5-11.8v-109.8l-20.5 11.8z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "bK",
    d: "m600.1 536.2l20.5-11.8v-109.8l-20.5 11.8z"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "bL",
    d: "m620.6 414.6l-20.4 10.9-20.6-10.9 19.9 12.2 0.6 109.4 1-109.5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "bM",
    d: "m629.8 373.5l-20.5 11.8 20.5 11.9 20.4-11.9z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "bN",
    d: "m609.3 541.3l20.5 11.8v-156l-20.5-11.8z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "bO",
    d: "m629.8 553.1l20.4-11.8v-156l-20.4 11.8z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "bP",
    d: "m629.8 553.1l20.4-11.8v-156l-20.4 11.8z"
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "bQ",
    d: "m650.2 385.3l-20.3 11-20.6-11 19.9 12.3 0.6 155.5 0.9-155.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "bR",
    d: "m660.2 344.8l-20.4 11.8 20.4 11.9 20.5-11.9z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "bS",
    d: "m639.8 558.2l20.4 11.9v-201.7l-20.4-11.8z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "bT",
    d: "m660.2 570.1l20.5-11.9v-201.6l-20.5 11.8z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "bU",
    d: "m660.2 570.1l20.5-11.9v-201.6l-20.5 11.8z"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "bV",
    d: "m680.7 356.6l-20.4 11-20.5-11 19.8 12.3 0.6 201.2 1-201.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "bW",
    d: "m300.1 14.9c-15.7-9-28.4-1.8-28.4 16.2v139.3c0 18 12.7 39.9 28.4 48.9l177 100.8c15.7 9 34.7 0.8 34.7-17.2v-139.3c0-18-19-38.9-34.7-48z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "bX",
    d: "m300.2 17.7c-15.5-8.9-28-1.8-28 16v137.4c0 17.7 12.5 39.4 28 48.3l175.5 99.9c15.5 9 33.8 0.9 33.8-16.9v-137.3c0-17.8-18.3-38.5-33.8-47.5z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "bY",
    d: "m300.3 20.5c-15.3-8.9-27.7-1.8-27.7 15.7v135.5c0 17.6 12.4 38.9 27.7 47.8l174.1 99.1c15.2 8.8 32.8 1 32.8-16.6v-135.5c0-17.5-17.6-38.1-32.8-46.9z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "bZ",
    d: "m300.4 23.3c-15.1-8.8-27.3-1.8-27.3 15.5v133.6c0 17.3 12.2 38.4 27.3 47.1l172.6 98.4c15.1 8.7 31.9 1 31.9-16.3v-133.6c0-17.3-16.8-37.7-31.9-46.4z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "c0",
    d: "m300.5 26c-14.9-8.6-27-1.7-27 15.4v131.7c0 17.1 12.1 37.9 27 46.5l171.1 97.6c14.9 8.6 31 1 31-16.1v-131.6c0-17.1-16.1-37.3-31-45.9z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "c1",
    d: "m300.6 28.8c-14.7-8.5-26.6-1.7-26.6 15.2v129.7c0 16.9 11.9 37.5 26.6 46l169.6 96.7c14.7 8.5 30.1 1.2 30.1-15.7v-129.7c0-16.9-15.4-36.9-30.1-45.4z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "c2",
    d: "m300.7 31.6c-14.5-8.4-26.3-1.7-26.3 15v127.8c0 16.6 11.8 36.9 26.3 45.3l168.1 96c14.6 8.4 29.2 1.2 29.2-15.4v-127.8c0-16.7-14.6-36.5-29.2-44.9z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "c3",
    d: "m300.8 34.4c-14.3-8.3-25.9-1.7-25.9 14.8v125.9c0 16.4 11.6 36.4 25.9 44.7l166.7 95.2c14.3 8.3 28.2 1.3 28.2-15.2v-125.9c0-16.4-13.9-36.1-28.2-44.3z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "c4",
    d: "m300.9 37.2c-14.1-8.2-25.6-1.7-25.6 14.5v124c0 16.2 11.5 36 25.6 44.1l165.2 94.5c14.1 8.1 27.3 1.3 27.3-14.9v-124c0-16.2-13.2-35.7-27.3-43.8z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "c5",
    d: "m301 39.9c-13.9-8-25.2-1.6-25.2 14.4v122.1c0 16 11.3 35.5 25.2 43.5l163.7 93.6c13.9 8.1 26.4 1.5 26.4-14.5v-122.1c0-16-12.5-35.3-26.4-43.3z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "c6",
    d: "m301.1 42.7c-13.7-7.9-24.9-1.6-24.9 14.2v120.2c0 15.7 11.2 34.9 24.9 42.9l162.2 92.8c13.8 7.9 25.5 1.5 25.5-14.3v-120.1c0-15.8-11.7-34.9-25.5-42.8z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m301.2 45.5c-13.6-7.8-24.5-1.6-24.5 14v118.2c0 15.6 10.9 34.5 24.5 42.3l160.7 92.1c13.6 7.8 24.6 1.5 24.6-14v-118.2c0-15.6-11-34.5-24.6-42.4z"
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "c8",
    d: "m301.1 29.2c-14.1-8.1-25.6-1.6-25.6 14.6v137.2c0 16.2 11.5 35.9 25.6 44.1l167.4 95.9c14.1 8.1 25.6 1.6 25.6-14.6v-137.2c0-16.2-11.5-35.9-25.6-44.1z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "c9",
    d: "m468.5 125.1l-167.4-95.9c-14.1-8.1-25.6-1.6-25.6 14.6v2.5c0-16.2 11.5-22.8 25.6-14.6l167.4 95.9c14.1 8.1 25.6 27.9 25.6 44.1v-2.5c0-16.2-11.5-35.9-25.6-44.1z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "m375 138.9l-7.4-4.4v106.8l7.4 4.4z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "m388.5 133.3l-7.3-4.4v120.1l7.3 4.4z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "m402.5 118.9l-7.3-4.3v142.4l7.3 4.4z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "m339.7 148.7v76.2l7.3 4.3v-76.1z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "m361 169.5l-7.3-4.4v67.8l7.3 4.3z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m416.2 146.6l-7.3-4.4v122.8l7.3 4.3z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m429.6 176.4l-7.3-4.4v100.8l7.3 4.4z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "ch",
    d: "m333.1 124.5l-7.4-4.4v78.4l7.4 22.3z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "m297.8 142.5v39.5l7.3 22.4v-57.5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m319.1 125.9l-7.3-4.4v86.5l7.3 4.4z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "m442.9 187.8l-7.3-4.4v97l7.3 4.4z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m456.5 179.9l-7.4-4.3v112.5l7.4 4.4z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "m470.4 156.8l-7.3-4.4v143.7l7.3 4.4z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "m375 145.8l-7.4-4.4v106.8l7.4 4.4z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "m388.5 157.5l-7.3-4.4v102.8l7.3 4.4z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "m402.5 149.5l-7.3-4.4v118.8l7.3 4.3z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m339.7 155.6v76.2l7.3 4.3v-76.1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "m361 172.7l-7.3-4.4v71.4l7.3 4.4z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "m416.2 165.9l-7.3-4.3v110.3l7.3 4.3z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "m429.6 183.3l-7.3-4.4v100.8l7.3 4.4z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cu",
    d: "m333.1 144.4l-7.4-4.3v83.2l7.4 4.4z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "m297.8 149.4v57.5l7.3 4.4v-57.6z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "m319.1 132.8l-7.3-4.4v86.5l7.3 4.4z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "m375 188.2l-7.4-4.3v64.3l7.4 4.4z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "m388.5 172.9l-7.3-4.4v87.4l7.3 4.4z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cz",
    d: "m402.5 184.1l-7.3-4.4v84.2l7.3 4.3z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m339.7 187.9v43.9l7.3 4.3v-43.8z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cB",
    d: "m361 185.1l-7.3-4.4v59l7.3 4.4z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cC",
    d: "m333.1 167.9l-7.4-4.3v59.7l7.4 4.4z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cD",
    d: "m297.8 177.5v29.4l7.3 4.4v-29.5z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cE",
    d: "m319.1 176.4l-7.3-4.4v42.9l7.3 4.4z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cF",
    d: "m416.2 209.9l-7.3-4.4v66.4l7.3 4.3z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cG",
    d: "m429.6 236.7l-7.3-4.4v47.5l7.3 4.4z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cH",
    d: "m442.9 194.6l-7.3-4.3v97l7.3 4.4z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m456.5 197.4l-7.4-4.4v102l7.4 4.4z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cJ",
    d: "m470.4 177l-7.3-4.3v130.3l7.3 4.4z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m442.9 213.4l-7.3-4.3v78.2l7.3 4.4z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cL",
    d: "m456.5 217.8l-7.4-4.4v81.6l7.4 4.4z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cM",
    d: "m470.4 233.6l-7.3-4.4v73.8l7.3 4.4z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m563 299.6q-0.1 0.1-0.1 0.2c0 0-6.3 6.4-11.4 20.4-7.2 19.9-31.7 85.8-31.7 85.8q-0.1 0.1-0.1 0.2c-0.1 0.5 0.1 1 0.5 1.6 1.1 1.2 6.9 3.9 8.5 3.6 0.8-0.2 1.3-0.5 1.5-1q0 0 0.1-0.1c0 0 22.6-67.2 29.9-87.1 5-13.9 4.5-22.7 4.5-22.7q0-0.2-0.1-0.5z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cO",
    d: "m563 300q-0.1 0-0.2 0.1c0 0-5.9 6.1-10.7 19.4-6.9 18.8-30.9 83.4-30.9 83.4q-0.1 0.1 0 0.1c-0.1 0.5 0 1 0.5 1.5 0.9 1.2 6.3 3.7 7.9 3.4 0.7-0.1 1.2-0.5 1.4-0.9q0-0.1 0-0.2c0 0 22.3-65.6 29.1-84.4 4.8-13.2 4.4-21.7 4.4-21.7q0.1-0.2-0.1-0.4z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cP",
    d: "m562.9 300.3q-0.1 0.1-0.2 0.1c0 0-5.5 5.9-10 18.4-6.5 17.8-30.1 80.9-30.1 80.9q0 0.2 0 0.2c-0.1 0.4 0.1 0.9 0.5 1.4 0.9 1.1 5.8 3.4 7.3 3.1 0.7-0.1 1.1-0.4 1.3-0.8q0.1-0.1 0.1-0.2c0 0 21.8-64.1 28.3-81.9 4.5-12.5 4.2-20.5 4.2-20.5q0.1-0.2-0.1-0.4z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cQ",
    d: "m562.8 300.6q-0.1 0.1-0.2 0.2c0 0-5 5.5-9.3 17.3-6.2 16.8-29.2 78.5-29.2 78.5q-0.1 0.1 0 0.2c-0.1 0.4 0 0.8 0.4 1.3 0.9 1.1 5.4 3.1 6.7 2.8 0.7-0.1 1.1-0.4 1.3-0.8q0 0 0-0.1c0 0 21.4-62.6 27.5-79.4 4.3-11.7 4.1-19.3 4.1-19.3q0.1-0.2-0.1-0.4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cR",
    d: "m562.7 300.9q-0.1 0.1-0.1 0.2c0 0-4.7 5.2-8.8 16.3-5.7 15.7-28.3 76.1-28.3 76.1q0 0.1 0 0.1c-0.1 0.4 0 0.8 0.4 1.3 0.8 1 4.9 2.8 6.2 2.6 0.6-0.1 1-0.4 1.1-0.8q0.1 0 0.1-0.1c0 0 20.9-61 26.6-76.8 4.1-11 4.1-18.2 4.1-18.2q0-0.2-0.1-0.4z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cS",
    d: "m562.6 301.3q-0.1 0-0.1 0.1c0 0-4.3 4.9-8.1 15.3-5.4 14.7-27.4 73.7-27.4 73.7q-0.1 0.1 0 0.1c-0.1 0.4 0 0.8 0.3 1.2 0.8 0.9 4.4 2.5 5.6 2.3 0.6-0.1 0.9-0.4 1.1-0.7q0-0.1 0-0.1c0 0 20.5-59.5 25.9-74.3 3.7-10.3 3.9-17 3.9-17q0-0.2-0.1-0.4z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cT",
    d: "m562.5 301.6q-0.1 0-0.1 0.1c0 0-3.9 4.6-7.4 14.2-5 13.8-26.6 71.3-26.6 71.3q0 0.1 0 0.2c-0.1 0.3 0 0.7 0.3 1.1 0.8 0.8 3.9 2.2 5 2 0.6-0.1 0.9-0.3 1-0.7q0.1 0 0.1-0.1c0 0 20-57.9 25-71.6 3.5-9.6 3.8-16 3.8-16q0.1-0.1-0.1-0.3z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cU",
    d: "m562.4 301.9q-0.1 0-0.1 0.1c0 0-3.5 4.4-6.7 13.2-4.6 12.7-25.7 68.9-25.7 68.9q-0.1 0.1-0.1 0.1-0.1 0.5 0.4 1c0.6 0.8 3.3 2 4.4 1.8 0.5-0.1 0.8-0.3 0.9-0.6q0 0 0.1-0.1c0 0 19.6-56.4 24.2-69.1 3.2-8.8 3.6-14.8 3.6-14.8q0.1-0.1-0.1-0.3z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m562.3 302.2q-0.1 0.1-0.1 0.1c0 0-3.1 4.1-6 12.2-4.3 11.7-24.9 66.5-24.9 66.5q0 0.1 0 0.1-0.1 0.4 0.3 0.9c0.6 0.7 2.9 1.7 3.8 1.5 0.5 0 0.7-0.2 0.9-0.5q0 0 0-0.1c0 0 19.2-54.9 23.4-66.5 3-8.2 3.5-13.7 3.5-13.7q0.1-0.1 0-0.3z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m562.2 302.6q-0.1 0-0.1 0c0 0-2.6 3.8-5.4 11.2-3.8 10.6-24 64.1-24 64.1q0 0 0 0.1-0.1 0.3 0.3 0.8c0.6 0.7 2.4 1.4 3.2 1.3q0.7-0.2 0.8-0.6 0 0 0.1 0c0 0 18.7-53.4 22.6-64 2.6-7.4 3.4-12.5 3.4-12.5q0-0.1-0.1-0.3z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cX",
    d: "m562.1 302.9q0 0-0.1 0.1c0 0-2.2 3.4-4.7 10.1-3.5 9.6-23.1 61.6-23.1 61.6q0 0.1 0 0.1-0.1 0.4 0.2 0.8c0.5 0.6 1.9 1.1 2.7 1q0.5-0.1 0.7-0.5 0 0 0 0c0 0 18.3-51.9 21.8-61.4 2.4-6.7 3.3-11.4 3.3-11.4q0-0.1-0.1-0.3z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cY",
    d: "m562 303.2q0 0-0.1 0.1c0 0-1.8 3.1-4 9.1-3.1 8.6-22.3 59.2-22.3 59.2q0 0.1 0 0.1-0.1 0.3 0.2 0.7c0.5 0.5 1.4 0.8 2.1 0.7q0.5-0.1 0.6-0.4 0.1 0 0.1-0.1c0 0 17.8-50.2 20.9-58.8 2.2-6 3.2-10.3 3.2-10.3q0 0 0-0.1z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cZ",
    d: "m467.4 360.2l-32.4 18.7v20.1l0.8 0.3 14.5-9.1z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "d0",
    d: "m465.4 358.7l-32.1 18.6-17.6-10.1v-1.4z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "d1",
    d: "m465.4 357.4l-32.1 18.6-17.6-10.2 15.2-8.7z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "d2",
    d: "m468.1 360.5l-32.3 18.7v20.1l15.2-8.8z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "d3",
    d: "m564.8 304.6c0 0.7-0.2 1.1-0.6 1.4l-129.8 75.9c-0.4 0.2-0.1-0.3-0.7-0.6-1.2-0.7-2.2-2.4-2.2-3.7 0-0.7-0.6-0.7-0.2-0.9 0 0 129.8-76 129.8-76 0.4-0.2 0.9-0.2 1.5 0.2 1.2 0.7 2.2 2.3 2.2 3.7z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "d4",
    d: "m434.9 380.6c0 1.3-0.9 1.9-2.1 1.2-1.2-0.7-2.2-2.4-2.2-3.7 0-1.4 1-2 2.2-1.3 1.2 0.7 2.1 2.4 2.1 3.8z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "d5",
    d: "m469.5 361.2l-32.2 17.2v1.3l17.6 10.2 15.2-8.8z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "d6",
    d: "m565.4 300.9c0.9 1.5-9.2 9-22.4 16.8-13.3 7.8-24.7 13-25.6 11.6-0.8-1.5 9.2-9 22.5-16.8 13.2-7.8 24.7-13 25.5-11.6z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "d7",
    d: "m469.5 359.8l-32.2 18.6 17.6 10.1 15.2-8.7z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "d8",
    d: "m467.4 356.7l-31.6 19.1-0.8-0.4v-20.1l15.3-8.8z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "d9",
    d: "m468.1 357.1l-32.3 18.7v-20.1l15.2-8.9z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "da",
    d: "m437.3 378.4l17.6 10.1 15.2-8.7-15.2 8.3z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "db",
    d: "m490.3 344c1 1.5-9.9 9.6-24.1 18-14.3 8.5-26.6 14-27.5 12.5-1-1.6 9.9-9.7 24.1-18.1 14.3-8.4 26.6-14 27.5-12.4z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "dc",
    d: "m182.8 245.1v92.3c35.6-20.5 65.6-62.8 76.6-108z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "dd",
    d: "m182.8 337.4l-7.2-4.1 0.2-91.4 7 3.2z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "m259.4 229.4l-7.2-4.2-76.6 15.7 7.2 4.2z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "df",
    d: "m115.1 249.5c10.4-42.8 44.8-82.8 76.8-89.3 9.7-2 18-0.7 24.6 3.2l9.3 6.9-0.6 1c8.9 11.6 11.6 31 5.9 54.5l-45.3 9.2-12.7 20.6v52c-6.8 3.9-12.5 6.2-18.9 7.5-6.5 1.3-12.4 1.1-17.7-0.4l-0.9 1.6c0 0-8.9-6.5-10-7.4l-1.4-1 0.1-0.2c-11.5-10.9-15.6-32.1-9.2-58.2z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "dg",
    d: "m180.3 243l58-11.8c10.4-42.8-7.1-72.2-39.2-65.6-32 6.5-66.4 46.5-76.8 89.3-10.4 42.8 7.1 72.1 39.1 65.6 6.4-1.3 12.1-3.6 18.9-7.5z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "m121.8 254.4c10.4-42.8 44.8-82.7 76.8-89.3 5.4-1.1 10.3-1.2 14.8-0.4-3.9-0.4-8.1-0.2-12.7 0.7-32 6.6-66.4 46.5-76.8 89.3-8.7 35.7 2.1 62 24.4 66-23.7-2.7-35.4-29.5-26.5-66.3z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "m391.1 522.4c-3.3-1.9-3.3-5.1 0-7l27.3-15.7c4.6-2.7 12.1-2.7 16.7 0 4.7 2.7 4.7 7 0.1 9.7l-24.4 14.1c-0.5 0.3-1.3 0.3-1.9 0-0.5-0.3-0.5-0.8 0-1.1l24.4-14.1c3.6-2.1 3.6-5.5 0-7.5-3.6-2.1-9.5-2.1-13.1-0.1l-27.3 15.8c-2.3 1.3-2.2 3.5 0 4.8 2.3 1.3 6.1 1.3 8.4 0l26.1-15.1c1.1-0.6 1-1.6 0-2.2-1-0.6-2.7-0.6-3.7 0l-21.8 12.6c-0.2 0.1-0.2 0.2 0 0.3 0.1 0 0.3 0 0.4 0l16-9.3c0.5-0.3 1.4-0.3 1.9 0 0.5 0.3 0.5 0.8 0 1.1l-16.1 9.2c-1.1 0.7-3 0.7-4.1 0-1.1-0.6-1.1-1.7 0-2.4l21.8-12.5c2-1.2 5.4-1.2 7.5 0 2 1.2 2 3.1 0 4.3l-26.2 15.1c-3.3 1.9-8.7 1.9-12 0z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "dj",
    d: "m391.1 521.7c-3.3-2-3.3-5.1 0-7l27.3-15.7c4.6-2.7 12.1-2.7 16.7 0 4.7 2.7 4.7 7 0.1 9.7l-24.4 14.1c-0.5 0.3-1.3 0.3-1.9 0-0.5-0.3-0.5-0.8 0-1.1l24.4-14.1c3.6-2.1 3.6-5.5 0-7.5-3.6-2.1-9.5-2.1-13.1-0.1l-27.3 15.8c-2.3 1.3-2.2 3.5 0 4.8 2.3 1.3 6.1 1.3 8.4 0l26.1-15.1c1.1-0.6 1-1.6 0-2.2-1-0.6-2.7-0.6-3.7 0l-21.8 12.6c-0.2 0.1-0.2 0.2 0 0.3 0.1 0 0.3 0 0.4 0l16-9.3c0.5-0.3 1.4-0.3 1.9 0 0.5 0.3 0.5 0.8 0 1.1l-16.1 9.2c-1.1 0.7-3 0.7-4.1 0-1.1-0.6-1.1-1.7 0-2.4l21.8-12.5c2-1.2 5.4-1.2 7.5 0 2 1.2 2 3.1 0 4.3l-26.2 15.1c-3.3 1.9-8.7 1.9-12 0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "dk",
    d: "m427.4 502.6c-1-0.6-2.7-0.6-3.7 0l-21.8 12.6c-0.2 0.1-0.2 0.2 0 0.3 0.1 0 0.3 0 0.4 0l16-9.3c0.2-0.1 0.4-0.1 0.6-0.1l4.8-2.8c1-0.6 2.7-0.6 3.7 0 0.4 0.3 0.6 0.5 0.7 0.8 0.2-0.5 0-1.1-0.7-1.5z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "dl",
    d: "m400 517.2c1.1 0.7 3 0.7 4.1 0l16.1-9.2c0.4-0.3 0.5-0.6 0.2-0.9q-0.1 0.1-0.2 0.2l-16.1 9.2c-1.1 0.7-3 0.7-4.1 0-0.4-0.2-0.6-0.5-0.7-0.8-0.2 0.5 0 1.1 0.7 1.5z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "dm",
    d: "m433.3 499.4c-3.6-2.1-9.5-2.1-13.1-0.1l-27.3 15.8c-1.3 0.7-1.8 1.8-1.6 2.7 0.1-0.7 0.6-1.4 1.6-2l27.3-15.8c3.6-2 9.5-2 13.1 0.1 1.7 0.9 2.5 2.1 2.7 3.4 0.1-1.5-0.7-3-2.7-4.1z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "dn",
    d: "m435.2 508l-24.4 14.1c-0.5 0.3-1.3 0.2-1.9 0q-0.1-0.1-0.2-0.2c-0.2 0.3-0.2 0.6 0.2 0.9 0.6 0.3 1.4 0.3 1.9 0l24.4-14.1c2.5-1.4 3.6-3.3 3.4-5.2-0.2 1.6-1.3 3.2-3.4 4.5z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "do",
    d: "m430.8 504.1c-0.2 0.6-0.6 1.3-1.5 1.8l-26.2 15.1c-3.3 1.9-8.7 1.9-12 0-1.5-0.9-2.3-2-2.4-3.2-0.2 1.4 0.6 2.8 2.4 3.9 3.3 1.9 8.7 1.9 12 0l26.2-15.1c1.2-0.7 1.6-1.6 1.5-2.5z"
  }))), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "m493.6 540.5c3.3-1.9 3.3-5 0-6.9l-27.3-15.8c-4.6-2.7-12.1-2.7-16.8 0-4.6 2.7-4.6 7 0 9.7l24.4 14.1c0.5 0.3 1.3 0.3 1.8 0 0.6-0.3 0.6-0.8 0-1.1l-24.4-14.1c-3.5-2.1-3.5-5.4 0.1-7.5 3.6-2.1 9.5-2.1 13 0l27.4 15.7c2.2 1.3 2.2 3.5-0.1 4.8-2.3 1.3-6 1.4-8.3 0l-26.1-15.1c-1.1-0.6-1.1-1.5 0-2.1 1-0.6 2.7-0.6 3.7 0l21.8 12.5c0.1 0.1 0.1 0.2 0 0.3-0.1 0.1-0.3 0.1-0.4 0l-16-9.3c-0.5-0.3-1.4-0.3-1.9 0-0.5 0.3-0.5 0.8 0 1.1l16 9.3c1.2 0.6 3 0.6 4.2 0 1.1-0.7 1.1-1.8 0-2.4l-21.8-12.6c-2.1-1.2-5.4-1.2-7.5 0-2 1.2-2.1 3.1 0 4.3l26.2 15.1c3.3 1.9 8.7 1.9 12 0z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "dp",
    d: "m493.6 539.6c3.3-1.9 3.3-5 0-6.9l-27.3-15.8c-4.6-2.6-12.1-2.6-16.8 0.1-4.6 2.6-4.6 7 0 9.6l24.4 14.1c0.5 0.3 1.3 0.3 1.8 0 0.6-0.3 0.6-0.8 0-1.1l-24.4-14c-3.5-2.1-3.5-5.5 0.1-7.6 3.6-2.1 9.5-2.1 13 0l27.4 15.8c2.2 1.3 2.2 3.4-0.1 4.8-2.3 1.3-6 1.3-8.3 0l-26.1-15.1c-1.1-0.6-1.1-1.6 0-2.2 1-0.6 2.7-0.6 3.7 0l21.8 12.6c0.1 0.1 0.1 0.2 0 0.2-0.1 0.1-0.3 0.1-0.4 0l-16-9.2c-0.5-0.3-1.4-0.3-1.9 0-0.5 0.3-0.5 0.8 0 1.1l16 9.2c1.2 0.7 3 0.7 4.2 0 1.1-0.7 1.1-1.7 0-2.4l-21.8-12.6c-2.1-1.2-5.4-1.2-7.5 0-2 1.2-2.1 3.2 0 4.3l26.2 15.2c3.3 1.9 8.7 1.9 12-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "dq",
    d: "m491.8 533.1l-27.4-15.7c-3.5-2.1-9.4-2.1-13 0-2 1.1-2.8 2.6-2.7 4.1 0.1-1.3 1-2.5 2.7-3.5 3.6-2.1 9.5-2.1 13 0l27.4 15.8c1 0.5 1.5 1.3 1.6 2 0.2-0.9-0.4-1.9-1.6-2.7z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "dr",
    d: "m457.3 521.3c1-0.6 2.7-0.6 3.7 0l5 2.9c0.1 0 0.3 0 0.4 0.1l16 9.2c0.1 0.1 0.3 0.1 0.4 0 0.1-0.1 0.1-0.2 0-0.2l-21.8-12.6c-1-0.6-2.7-0.6-3.7 0-0.7 0.4-0.9 0.9-0.7 1.4 0.1-0.3 0.3-0.6 0.7-0.8z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "ds",
    d: "m484.7 534.6c-1.2 0.6-3 0.6-4.2 0l-16-9.3q-0.2-0.1-0.3-0.2c-0.2 0.3-0.1 0.6 0.3 0.9l16 9.2c1.2 0.7 3 0.7 4.2 0 0.7-0.4 0.9-1 0.7-1.5-0.1 0.3-0.3 0.6-0.7 0.9z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "dt",
    d: "m476 539.9q-0.1 0.1-0.3 0.2c-0.5 0.3-1.3 0.3-1.8 0l-24.4-14.1c-2.2-1.2-3.3-2.9-3.4-4.5-0.2 1.8 0.9 3.7 3.4 5.1l24.4 14.1c0.5 0.3 1.3 0.3 1.8 0 0.4-0.2 0.5-0.6 0.3-0.8z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "du",
    d: "m493.6 539c-3.3 1.9-8.7 1.9-12 0l-26.2-15.1c-0.9-0.5-1.4-1.1-1.5-1.8-0.1 0.9 0.3 1.8 1.5 2.5l26.2 15.1c3.3 1.9 8.7 1.9 12-0.1 1.8-1 2.6-2.4 2.4-3.8-0.1 1.2-0.9 2.3-2.4 3.2z"
  }))), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "m507.9 547.3c-4.3 0.7-9.2-0.6-10.9-2.9l-14.4-19c-2.4-3.2 0.5-6.6 6.6-7.5 6-0.9 12.9 0.9 15.3 4.1l12.8 17c0.3 0.3 0 0.7-0.7 0.8-0.7 0.1-1.4-0.1-1.7-0.4l-12.8-17c-1.9-2.5-7.3-3.9-12-3.2-4.7 0.7-7 3.3-5.1 5.8l14.4 19c1.2 1.6 4.6 2.5 7.6 2.1 3-0.5 4.4-2.2 3.2-3.8l-13.7-18.1c-0.6-0.8-2.1-1.2-3.5-1-1.3 0.3-2 1-1.4 1.7l11.4 15.2c0.1 0 0.3 0.1 0.4 0.1 0.2-0.1 0.2-0.1 0.2-0.2l-8.4-11.2c-0.3-0.3 0-0.7 0.7-0.8 0.7-0.1 1.4 0.1 1.7 0.5l8.4 11.1c0.6 0.8-0.1 1.6-1.6 1.9-1.5 0.2-3.2-0.3-3.8-1.1l-11.5-15.1c-1-1.4 0.3-2.9 3-3.3 2.7-0.5 5.7 0.4 6.8 1.8l13.7 18.2c1.8 2.3-0.3 4.7-4.7 5.3z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "dv",
    d: "m507.9 546.5c-4.3 0.7-9.2-0.7-10.9-3l-14.4-18.9c-2.4-3.2 0.5-6.6 6.6-7.5 6-1 12.9 0.9 15.3 4.1l12.8 16.9c0.3 0.4 0 0.8-0.7 0.9-0.7 0.1-1.4-0.1-1.7-0.5l-12.8-17c-1.9-2.4-7.3-3.9-12-3.2-4.7 0.8-7 3.4-5.1 5.9l14.4 19c1.2 1.5 4.6 2.5 7.6 2 3-0.5 4.4-2.1 3.2-3.7l-13.7-18.2c-0.6-0.7-2.1-1.1-3.5-0.9-1.3 0.2-2 0.9-1.4 1.7l11.4 15.1c0.1 0.1 0.3 0.1 0.4 0.1 0.2 0 0.2-0.1 0.2-0.2l-8.4-11.1c-0.3-0.4 0-0.7 0.7-0.8 0.7-0.1 1.4 0.1 1.7 0.4l8.4 11.1c0.6 0.8-0.1 1.7-1.6 1.9-1.5 0.2-3.2-0.2-3.8-1l-11.5-15.2c-1-1.4 0.3-2.9 3-3.3 2.7-0.4 5.7 0.4 6.8 1.8l13.7 18.2c1.8 2.3-0.3 4.7-4.7 5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "dw",
    d: "m495.3 527.4c-0.2 0.2-0.3 0.4-0.1 0.6l7.9 10.5q0.1 0.1 0.3 0c0.2 0 0.2-0.1 0.2-0.2z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "dx",
    d: "m510.2 540.7l-13.7-18.2c-0.6-0.7-2.1-1.1-3.5-0.9-1.2 0.2-1.9 0.9-1.5 1.6 0.3-0.4 0.8-0.7 1.5-0.8 1.4-0.2 2.9 0.2 3.5 0.9l13.7 18.2q0.3 0.3 0.4 0.7c0.1-0.5 0-1-0.4-1.5z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "m517.2 537.9q-0.2 0.2-0.6 0.3c-0.7 0.1-1.4-0.1-1.7-0.5l-12.8-16.9c-1.9-2.5-7.3-4-12-3.2-3.8 0.6-6 2.4-5.7 4.4 0.3-1.7 2.4-3.1 5.7-3.7 4.7-0.7 10.1 0.8 12 3.2l12.8 17c0.3 0.4 1 0.6 1.7 0.5 0.7-0.1 1-0.5 0.7-0.9z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "dz",
    d: "m489.1 524.4l11.5 15.2c0.6 0.8 2.3 1.2 3.8 1 1.4-0.2 2.1-1 1.7-1.7-0.3 0.4-0.8 0.8-1.7 0.9-1.5 0.3-3.2-0.2-3.8-1l-11.5-15.1q-0.2-0.3-0.3-0.6c-0.1 0.4 0 0.9 0.3 1.3z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "dA",
    d: "m507.9 545.7c-4.3 0.7-9.2-0.6-10.9-2.9l-14.4-19c-0.5-0.7-0.7-1.3-0.8-1.9-0.1 0.8 0.1 1.7 0.8 2.7l14.4 18.9c1.7 2.3 6.6 3.7 10.9 3 3.6-0.6 5.6-2.3 5.3-4.1-0.3 1.5-2.2 2.8-5.3 3.3z"
  }))), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "dB",
    d: "m32.4 484.7c-2.8 5.3-0.8 11.8 4.4 14.6 5.2 2.8 11.7 0.9 14.6-4.3 2.8-5.3 0.8-11.8-4.4-14.6-5.2-2.8-11.8-0.9-14.6 4.3z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "dC",
    d: "m75.1 401.4l23.3 12.5-43.4 79.8q0 0.1 0 0.1c-2.1 3.8-8.9 4-15.3 0.6-6.5-3.5-10.1-9.4-8-13.1q0-0.1 0-0.1z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "dD",
    d: "m75.1 401.4l23.3 12.5-43.4 79.8q0 0.1 0 0.1c-2.1 3.8-8.9 4-15.3 0.6-6.5-3.5-10.1-9.4-8-13.1q0-0.1 0-0.1z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "dE",
    d: "m75.1 401.4c-2 3.8 1.5 9.6 8 13.1 6.4 3.5 13.3 3.2 15.3-0.5 2-3.8-1.6-9.6-8-13.1-6.4-3.4-13.3-3.2-15.3 0.5z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "dF",
    d: "m88.8 387.6l13.8 7.5-8.2 15q0 0.1-0.1 0.1c-1.2 2.2-5.2 2.4-9.1 0.3-3.8-2.1-5.9-5.5-4.7-7.8q0 0 0 0z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "dG",
    d: "m31 506.5c-2.4 4.5-0.7 10.2 3.8 12.6 4.5 2.5 10.2 0.8 12.6-3.7 2.5-4.6 0.8-10.2-3.8-12.7-4.5-2.4-10.1-0.7-12.6 3.8z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "dH",
    d: "m211.7 247.1c0 55.2-39 122.5-87.1 150.2-48.1 27.8-87.1 5.6-87.1-49.6 0-55.2 39-122.5 87.1-150.2 48.1-27.8 87.1-5.6 87.1 49.6z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "dI",
    d: "m234.8 325.5l-137.5 79.3v-149.3l137.5-79.3z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "dJ",
    d: "m186.3 249.2v124.7c48-27.7 88.5-84.9 103.4-145.8z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "dK",
    d: "m186.3 373.9l-9.7-5.7 0.2-123.3 9.5 4.3z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "dL",
    d: "m289.7 228.1l-9.7-5.7-103.4 21.1 9.7 5.7z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "dM",
    d: "m94.9 255.1c14-57.7 60.5-111.7 103.7-120.5 13-2.7 24.2-0.9 33.2 4.4v-0.1l12.6 9.3-0.8 1.3c11.9 15.8 15.6 42 7.9 73.6l-61.1 12.5-17.2 27.8v70.2c-9.1 5.2-16.8 8.3-25.5 10-8.8 1.9-16.8 1.6-23.9-0.4l-1.2 2.1c0 0-12.1-8.7-13.6-10l-1.8-1.3 0.1-0.2c-15.5-14.9-21-43.4-12.4-78.7z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "dN",
    d: "m182.9 246.4l78.3-16c14-57.7-9.6-97.4-52.9-88.5-43.2 8.8-89.7 62.8-103.7 120.5-14 57.7 9.6 97.4 52.9 88.5 8.6-1.7 16.3-4.8 25.4-10z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "dO",
    d: "m104 261.8c14-57.8 60.4-111.7 103.7-120.6 7.2-1.4 13.8-1.5 19.8-0.5-5.2-0.6-10.9-0.3-17 0.9-43.2 8.9-89.7 62.8-103.7 120.6-11.7 48.1 2.8 83.6 33 89-32.1-3.6-47.9-39.8-35.8-89.4z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "dP",
    d: "m163.2 332.1v69.6l-23 13.2v-69.5l-16.3 9.4 27.8-57.6 27.8 25.5z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "dQ",
    d: "m136 385c36.7-21.1 66.3-72.3 66.3-114.4 0-16.8-4.7-29.7-12.9-37.6 15.5 5 25.4 20.9 25.4 45.2 0 42-29.7 93.2-66.3 114.4-21.9 12.6-41.3 11.6-53.4-0.2 11.3 3.7 25.5 1.5 40.9-7.4z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "dR",
    d: "m145.3 242.2c34.7-20 62.7-4 62.7 35.8 0 39.7-28 88.2-62.7 108.2-34.6 20-62.7 4-62.7-35.8 0-39.7 28.1-88.2 62.7-108.2z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "dS",
    d: "m145.3 242.2c34.7-20 62.7-4 62.7 35.8 0 39.7-28 88.2-62.7 108.2-34.6 20-62.7 4-62.7-35.8 0-39.7 28.1-88.2 62.7-108.2z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "dT",
    d: "m134.4 232.4c18-10.4 34.4-11.6 46.3-5.1 0.3 0.1 17.5 9.7 18 10.5-12.1-9.1-30.1-9-50.2 2.6-36.6 21.1-66.3 72.3-66.3 114.4 0 21.4 7.7 36.3 20.2 42.9-0.9-0.2-2-0.7-3.3-1.4-0.3-0.2-12-7.3-12.4-7.5-11.5-7-18.6-21.5-18.6-42.1 0-42 29.7-93.2 66.3-114.3z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "dU",
    d: "m148.5 240.4c36.6-21.1 66.3-4.2 66.3 37.8 0 42-29.7 93.2-66.3 114.4-36.6 21.1-66.3 4.2-66.3-37.8 0-42.1 29.7-93.3 66.3-114.4zm0.5 147.1c33.8-19.5 61.2-66.8 61.2-105.6 0-38.7-27.4-54.4-61.2-34.9-33.8 19.6-61.3 66.8-61.3 105.6 0 38.8 27.5 54.4 61.3 34.9z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "dV",
    d: "m145.3 238.8c17.6-10.1 33.5-11.5 45.4-5.6-11.1-3-27.3-1.4-42.2 7.2-36.6 21.1-66.3 72.3-66.3 114.4 0 21.8 10.6 37.5 23.5 44-16.2-4.6-26.7-20.7-26.7-45.6 0-42 29.7-93.2 66.3-114.4z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "dW",
    d: "m154.1 292.4c-11.1-11.1-22.9-20.5-35.2-28.3 8-8.9 17-16.4 26.4-21.9 34.7-20 62.7-4 62.7 35.8 0 20-7.1 42.2-18.5 61.8-8.9-16.6-20.7-32.7-35.4-47.4z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "dX",
    d: "m138.7 375.7c0 12.5 10.1 22.6 22.6 22.6 12.5 0 22.6-10.1 22.6-22.6 0-12.5-10.1-22.6-22.6-22.6-12.5 0-22.6 10.1-22.6 22.6z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "dY",
    d: "m59.6 357.7c0 12.5 10.1 22.6 22.6 22.6 12.5 0 22.6-10.1 22.6-22.6 0-12.4-10.1-22.6-22.6-22.6-12.5 0-22.6 10.2-22.6 22.6z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m101.2 252.4c0 12.5 10.1 22.6 22.6 22.6 12.5 0 22.6-10.1 22.6-22.6 0-12.5-10.1-22.6-22.6-22.6-12.5 0-22.6 10.1-22.6 22.6z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m135.1 271.5c0 28.5 23.1 51.6 51.6 51.6 28.5 0 51.7-23.1 51.7-51.6 0-28.5-23.2-51.7-51.7-51.7-28.5 0-51.6 23.2-51.6 51.7z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "e1",
    d: "m49.3 358.4c0 28.5 23.2 51.6 51.7 51.6 28.5 0 51.6-23.1 51.6-51.6 0-28.5-23.1-51.7-51.6-51.7-28.5 0-51.7 23.2-51.7 51.7z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m35.1 554c-1.4-1.3-2.2-2.9-2.2-4.4-0.1-0.9 1.2-1.6 2.8-1.6 2.1 0 4.3-0.3 6.3-0.7 1.1 0.3 3 0.5 4-0.1 1-0.6 1.4-1.4 0.9-2 4.2-2.6 6.1-5.8 0.1-9.3-5.9-3.4-11.4-2.3-16 0.1-1-0.2-2.4 0-3.4 0.6-1.1 0.6-0.8 1.6-0.2 2.3-0.8 1.1-1.1 2.4-1.1 3.6 0 0.9-1.3 1.7-2.9 1.6-2.7 0-5.3-0.4-7.6-1.3-3.1-1.1-7.2-0.9-9.9 0.7l-4.7 2.7c-0.9 0.5-0.8 1.3 0.1 1.8l24.8 14.4c0.9 0.5 2.4 0.5 3.3 0l4.6-2.7c2.7-1.5 3.1-3.9 1.1-5.7z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e2",
    d: "m293.1 626.1c-8.7 5-22.8 4.9-31.4-0.1-8.7-5-8.8-13.1-0.1-18.1 8.6-5 22.7-4.9 31.4 0.1 8.6 5 8.7 13.1 0.1 18.1zm-9.8-9.9c-1.2 0.7-1.2 1.9 0.1 2.6 1.2 0.8 3.3 0.8 4.5 0.1 1.3-0.8 1.3-1.9 0-2.7-1.3-0.7-3.3-0.7-4.6 0zm-9.2-5.3c-1.3 0.7-1.3 1.9 0 2.6 1.3 0.7 3.3 0.7 4.6 0 1.2-0.7 1.2-1.9-0.1-2.6-1.2-0.8-3.3-0.8-4.5 0zm5.6 14.1c0.9-0.1 1.3-0.7 0.9-1.2-0.4-0.4-1.2-0.6-1.9-0.5-3.5 0.6-7.3 0.1-9.9-1.4-2.5-1.5-3.5-3.6-2.5-5.6 0.2-0.4-0.2-0.9-0.9-1.1-0.9-0.2-2 0.1-2.2 0.6-1.3 2.6 0 5.4 3.3 7.4 3.5 2 8.6 2.7 13.2 1.8z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e2",
    d: "m482.5 589.1c-5.7 3.3-14.1 4-21.1 2.2l-13.3 1 6.6-3.8c-6.5-4.4-6.2-10.9 0.8-15 7.5-4.2 19.5-4.2 27 0.1 7.4 4.3 7.5 11.2 0 15.5zm-17.2-11.8c0-0.9-1.4-1.7-3-1.7-1.6 0-3 0.8-2.9 1.7 0 1 1.3 1.7 2.9 1.7 1.7 0 3-0.7 3-1.7zm6.8 4c0-1-1.3-1.7-3-1.7-1.6 0-2.9 0.7-2.9 1.7 0 0.9 1.3 1.7 2.9 1.7 1.7 0 3-0.8 3-1.7zm6.8 3.9c0-0.9-1.3-1.7-3-1.7-1.6 0-2.9 0.8-2.9 1.7 0 0.9 1.3 1.7 3 1.7 1.6 0 2.9-0.7 2.9-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e3",
    d: "m234.2 591.8c-1.5 0.8-3.7 0.8-5.1-0.1h-0.1c0.4 0.7 0.1 1.5-0.9 2.1-1.4 0.8-3.6 0.8-5 0-0.1 0.5-0.5 1-1.2 1.3-1.4 0.8-3.7 0.7-5-0.1l-3.7-2.1-6.9-4-5.6-3.2c-0.9-0.5-1.1-1.3-0.7-2-0.8 0.4-2 0.4-2.7 0l-6.7-3.9c-0.8-0.4-0.8-1.1 0-1.5l13.6-8c0.8-0.4 2-0.4 2.8 0.1l6.7 3.8c0.8 0.5 0.8 1.2 0 1.6l-1.3 0.8 10-0.2c1.8 0 3.5-0.5 4.8-1.2l4.4-2.5c0.6-0.4 1.7-0.4 2.4 0 2.2 1.2 2.2 3.2 0.1 4.5l-5.2 2.9 10.2 5.9c1.4 0.9 1.4 2.2 0 3-1.1 0.7-2.8 0.8-4.2 0.4 0.7 0.8 0.5 1.8-0.7 2.4zm-22.5-16.8l-6.1-3.5-13.1 7.5 6.1 3.6z"
  }))), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e2",
    d: "m172.9 555.1c-9.2 5.3-24.2 5.2-33.5-0.1-9.3-5.3-9.3-14-0.1-19.3 9.2-5.3 24.2-5.3 33.5 0 9.2 5.4 9.3 14 0.1 19.4zm-3.4-18.7c-2.5-0.7-6.2-0.5-10.2 0.5q1.8 1.6 4.1 3zm-12.8 1.2c-2.3 0.8-4.6 1.8-6.8 2.9l6.2 3.7 5.3-3.1c-1.8-1.1-3.4-2.3-4.7-3.5zm-8.9 4.1c-2.1 1.3-3.8 2.6-5 4 2 0.7 4.1 1.6 6 2.7l5.2-3zm-6.3 5.4c-1.7 2.4-2.1 4.5-0.8 5.9l6.1-3.5c-1.7-0.9-3.5-1.7-5.3-2.4zm1.3 7.1c2.5 0.8 6.2 0.6 10.2-0.4q-1.8-1.6-4.1-3.1zm12.8-1.2c2.3-0.7 4.6-1.7 6.8-2.9l-6.2-3.6-5.3 3c1.8 1.1 3.4 2.3 4.7 3.5zm8.9-4.1c2.1-1.3 3.8-2.6 5-3.9-2-0.8-4.1-1.7-6-2.7l-5.2 3zm6.3-5.5c1.7-2.3 2.1-4.4 0.8-5.9l-6.1 3.5c1.7 0.9 3.5 1.7 5.3 2.4zm2.6 0.9q1.7 0.5 3.4 0.8c-0.1-1.5-0.6-3-1.6-4.4q-0.4 1.7-1.8 3.6zm-9.4-10.1c-2.5-0.5-5.1-0.8-7.7-0.9q0.6 1 1.5 2c2.1-0.6 4.2-0.9 6.2-1.1zm-10.7-0.8c-3.9 0.3-7.7 1.2-10.8 2.8l5.2 3c2.4-1.3 4.9-2.3 7.4-3.2q-1.1-1.3-1.8-2.6zm-12.9 4c-2.7 1.8-4.3 4-4.8 6.3q2.2 0.3 4.5 1c1.4-1.4 3.3-2.9 5.5-4.3zm-5 8c0.1 1.5 0.6 3 1.6 4.4q0.4-1.7 1.8-3.5-1.7-0.5-3.4-0.9zm12.8 10.9c2.5 0.6 5.1 0.9 7.7 0.9q-0.6-0.9-1.5-1.9c-2.1 0.5-4.2 0.9-6.2 1zm10.7 0.8c3.9-0.3 7.7-1.2 10.8-2.8l-5.2-3c-2.4 1.3-4.9 2.4-7.4 3.2q1.1 1.3 1.8 2.6zm12.9-4c2.7-1.8 4.3-4 4.8-6.2q-2.2-0.4-4.5-1.1c-1.4 1.5-3.3 2.9-5.5 4.3z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m366.2 579.8h-13.5c-2.4 3.7-9.7 4.7-13.2 4.7-3.5-0.1-10.8-1-13.2-4.8h-13.6c0.8 5.5 12.5 8.1 26.8 8.2 14.3 0 26-2.6 26.7-8.1zm-39.8-2.1c0-1.1-1.6-2-3.5-2h-6.7c-1.9 0-3.5 0.9-3.5 2v1.5h13.7zm26.2 1.6h13.6v-1.5c0-1.1-1.5-2-3.4-2h-6.8c-1.9 0-3.4 0.9-3.4 2z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e2",
    d: "m558.9 619.7l-1.2 0.7c-6.1 3.5-14.8 4.6-22.5 3.2-3.6 0.9-6.8 1.3-9.5 1.3-2.2-0.1-4.3 0.3-5.9 1.2l-0.7 0.4c-1.4 0.9-2.1 2-2.2 3.1-0.1 0.7-0.5 1.3-1.3 1.8l-8.7-5c0.8-0.5 1.9-0.7 3-0.8 2 0 3.9-0.4 5.4-1.3l0.7-0.4c1.6-0.9 2.2-2.1 2.2-3.4-0.1-1.5 0.6-3.4 2.1-5.4-2.4-4.5-0.5-9.5 5.5-13l1.3-0.8 5.7 3.3q0.7-0.5 1.5-0.9l20.6 11.8q-0.8 0.5-1.7 0.9zm-35.9-7.6c1.9-2 4.4-4 7.4-5.9l-3.2-1.9c-3.2 2.2-4.6 5-4.2 7.8zm30.8 7.6l-3.2-1.9c-3.4 1.7-6.9 3.2-10.2 4.3 4.7 0.2 9.6-0.6 13.4-2.4z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e2",
    d: "m109.5 591.2c-9.2 5.3-24.2 5.3-33.5-0.1-9.3-5.3-9.3-14-0.1-19.3 9.2-5.3 24.2-5.3 33.5 0.1 9.3 5.3 9.3 14 0.1 19.3zm-3.4-2c7.4-4.2 7.4-11.1 0-15.4-7.5-4.3-19.5-4.3-26.8-0.1-7.4 4.3-7.4 11.2 0.1 15.5 7.4 4.3 19.4 4.3 26.7 0zm-3.3-1.9c-5.6 3.2-14.5 3.2-20.1 0-5.6-3.2-5.6-8.4-0.1-11.6 5.6-3.2 14.6-3.2 20.1 0 5.6 3.2 5.6 8.4 0.1 11.6zm-3.4-1.9c3.7-2.2 3.7-5.6 0-7.8-3.7-2.1-9.7-2.1-13.4 0-3.7 2.1-3.7 5.6 0 7.7 3.7 2.2 9.7 2.2 13.4 0.1zm-3.3-2c-1.9 1.1-4.9 1.1-6.7 0-1.9-1.1-1.9-2.8-0.1-3.8 1.9-1.1 4.9-1.1 6.7 0 1.9 1 1.9 2.8 0.1 3.8z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m372.1 618.8l5.5 3.3c0.5 0.2 1.3 0.2 1.8 0l10.7-6.2c0.5-0.3 0.5-0.8 0-1.1l-5.5-3.2c-0.5-0.3-1.3-0.3-1.8 0l-10.7 6.2c-0.5 0.3-0.5 0.8 0 1zm9.9 5.8l5.6 3.2c0.5 0.3 1.3 0.3 1.8 0l21.1-12.2c0.5-0.3 0.5-0.7 0-1l-5.5-3.2c-0.5-0.3-1.3-0.3-1.8 0l-21.2 12.2c-0.5 0.3-0.5 0.7 0 1zm41.6-13.5l-31.6 18.2c-0.5 0.3-0.5 0.8 0 1.1l5.6 3.2c0.5 0.3 1.3 0.3 1.7 0l31.6-18.3c0.5-0.3 0.5-0.7 0-1l-5.5-3.2c-0.5-0.3-1.3-0.3-1.8 0z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m578.9 587.3l-12.8-2.3c-1.2-0.2-1.5-1.2-0.5-1.6l11-4.5c0.4-0.1 0.6-0.4 0.6-0.7l-0.2-7.7c0-0.8 1.4-1.2 2.5-0.8l10.8 4.7c0.4 0.2 0.9 0.2 1.4 0.1l12.7-2.4c1.2-0.3 2.3 0.4 1.9 1.1l-4.2 7.3c-0.2 0.3-0.1 0.6 0.2 0.8l8.1 6.3c0.7 0.6 0 1.4-1.3 1.4l-13.4-0.1c-0.5 0-1 0.1-1.3 0.3l-7.7 6.4c-0.8 0.6-2.3 0.4-2.7-0.3l-4.1-7.4c-0.1-0.3-0.5-0.5-1-0.6z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "m125.6 180.3c0-0.5-0.4-0.7-0.8-0.5l-11.5 6.7c-0.4 0.2-0.8 0.8-0.8 1.3 0 0.5 0.4 0.7 0.8 0.5l11.5-6.6c0.4-0.3 0.8-0.9 0.8-1.4zm-13.1 11.6c0 0.5 0.4 0.7 0.8 0.4l11.5-6.6c0.4-0.2 0.8-0.8 0.8-1.3 0-0.5-0.4-0.7-0.8-0.5l-11.5 6.6c-0.4 0.3-0.8 0.9-0.8 1.4zm0 4.1c0 0.5 0.4 0.7 0.8 0.4l11.5-6.6c0.4-0.2 0.8-0.8 0.8-1.3 0-0.5-0.4-0.8-0.8-0.5l-11.5 6.6c-0.4 0.3-0.8 0.9-0.8 1.4z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "m194.9 142.1c0 1.2 0.9 1.7 2 1.1 1-0.6 1.9-2.1 1.9-3.3 0-1.2-0.9-1.7-1.9-1.1-1.1 0.6-2 2.1-2 3.3z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "m200.7 138.8c0 1.2 0.9 1.7 1.9 1.1 1.1-0.7 1.9-2.1 1.9-3.3 0-1.2-0.8-1.7-1.9-1.1-1 0.6-1.9 2.1-1.9 3.3z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "m206.5 135.4c0 1.2 0.8 1.7 1.9 1.1 1-0.6 1.9-2.1 1.9-3.3 0-1.2-0.9-1.7-1.9-1.1-1.1 0.6-1.9 2.1-1.9 3.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.e7da1c95aab49d52da05c0264a83e7a3.svg";
export { ForwardRef as ReactComponent };